/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.9.0 (NJsonSchema v10.4.1.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AdminAlertService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all.
     * @param model The request model.
     * @return A list of AlertDto.
     */
    getByStatus(model: AdminAlertRequest): Observable<AdminAlertResponse> {
        let url_ = this.baseUrl + "/api/AdminAlert/GetByStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStatus(<any>response_);
                } catch (e) {
                    return <Observable<AdminAlertResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdminAlertResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetByStatus(response: HttpResponseBase): Observable<AdminAlertResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdminAlertResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdminAlertResponse>(<any>null);
    }

    /**
     * Updates the status.
     * @param model The model.
     * @return A list of AlertDto.
     */
    updateStatus(model: AdminAlertRequest): Observable<AdminAlertResponse> {
        let url_ = this.baseUrl + "/api/AdminAlert/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<AdminAlertResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdminAlertResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<AdminAlertResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdminAlertResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdminAlertResponse>(<any>null);
    }

    /**
     * Updates the status.
     * @return A list of AlertDto.
     */
    closeAlert(model: CloseAlertRequest): Observable<AdminAlertResponse> {
        let url_ = this.baseUrl + "/api/AdminAlert/CloseAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseAlert(<any>response_);
                } catch (e) {
                    return <Observable<AdminAlertResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdminAlertResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCloseAlert(response: HttpResponseBase): Observable<AdminAlertResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdminAlertResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdminAlertResponse>(<any>null);
    }
}

@Injectable()
export class AdminUserCustomersService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    update(model: UpdateAdminUserCustomersModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AdminUserCustomers/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class AgreementsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds the specified agreement.
     * @param addAgreementRequest The add agreement request.
     * @return The agreement id.
     */
    add(addAgreementRequest: AddAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addAgreementRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the specified agreement.
     * @param agreementNumber (optional) The agreement number.
     * @param locationName (optional) Name of the location.
     * @param assetTypeName (optional) Name of the asset type.
     * @param wasteTypeName (optional) Name of the waste type.
     * @return The agreement id.
     */
    addByName(agreementNumber: string | null | undefined, locationName: string | null | undefined, assetTypeName: string | null | undefined, wasteTypeName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/AddByName?";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        if (locationName !== undefined && locationName !== null)
            url_ += "locationName=" + encodeURIComponent("" + locationName) + "&";
        if (assetTypeName !== undefined && assetTypeName !== null)
            url_ += "assetTypeName=" + encodeURIComponent("" + assetTypeName) + "&";
        if (wasteTypeName !== undefined && wasteTypeName !== null)
            url_ += "wasteTypeName=" + encodeURIComponent("" + wasteTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddByName(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddByName(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * ImportAgreement.
     * @param customerId (optional) The customer identifier.
     * @param agreementNumber (optional) The agreement number.
     * @return The result.
     */
    importAgreement(customerId: string | undefined, agreementNumber: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/ImportAgreement?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAgreement(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processImportAgreement(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Updates the contact details.
     * @param customerId (optional) The customer identifier.
     * @param agreementNumber (optional) The agreement number.
     * @param contactEmail (optional) The contact email.
     * @param contactName (optional) The contact name.
     * @param contactNumber (optional) The contact number.
     * @return The result.
     */
    updateContactDetails(customerId: string | undefined, agreementNumber: string | null | undefined, contactEmail: string | null | undefined, contactName: string | null | undefined, contactNumber: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/UpdateContactDetails?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        if (contactEmail !== undefined && contactEmail !== null)
            url_ += "contactEmail=" + encodeURIComponent("" + contactEmail) + "&";
        if (contactName !== undefined && contactName !== null)
            url_ += "contactName=" + encodeURIComponent("" + contactName) + "&";
        if (contactNumber !== undefined && contactNumber !== null)
            url_ += "contactNumber=" + encodeURIComponent("" + contactNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContactDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContactDetails(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateContactDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Updates the notes.
     * @param customerId (optional) The customer identifier.
     * @param agreementNumber (optional) The agreement number.
     * @param notes (optional) The notes.
     * @return The result.
     */
    updateNotes(customerId: string | undefined, agreementNumber: string | null | undefined, notes: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/UpdateNotes?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        if (notes !== undefined && notes !== null)
            url_ += "notes=" + encodeURIComponent("" + notes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotes(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNotes(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the agreement rental amount.
     * @param customerId (optional) The customer identifier.
     * @param agreementNumber (optional) The agreement number.
     * @param isCustomRental (optional) if set to true [is custom remntal].
     * @param rentalAmount (optional) The rental amount.
     * @return The result.
     */
    addAgreementRentalAmount(customerId: string | undefined, agreementNumber: string | null | undefined, isCustomRental: boolean | undefined, rentalAmount: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/AddAgreementRentalAmount?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        if (isCustomRental === null)
            throw new Error("The parameter 'isCustomRental' cannot be null.");
        else if (isCustomRental !== undefined)
            url_ += "isCustomRental=" + encodeURIComponent("" + isCustomRental) + "&";
        if (rentalAmount === null)
            throw new Error("The parameter 'rentalAmount' cannot be null.");
        else if (rentalAmount !== undefined)
            url_ += "rentalAmount=" + encodeURIComponent("" + rentalAmount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgreementRentalAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgreementRentalAmount(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddAgreementRentalAmount(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the agreement rental amounts.
     * @param request The request.
     * @return The list of agreements.
     */
    addAgreementRentalAmounts(request: AddAgreementRentalAmountsRequest): Observable<AddAgreementRentalAmountsResponse> {
        let url_ = this.baseUrl + "/api/Agreements/AddAgreementRentalAmounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgreementRentalAmounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgreementRentalAmounts(<any>response_);
                } catch (e) {
                    return <Observable<AddAgreementRentalAmountsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddAgreementRentalAmountsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddAgreementRentalAmounts(response: HttpResponseBase): Observable<AddAgreementRentalAmountsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddAgreementRentalAmountsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddAgreementRentalAmountsResponse>(<any>null);
    }

    /**
     * Gets the rental total.
     * @param rentalDays (optional) The rental days.
     * @param rentalAmount (optional) The rental amount.
     * @param daysOnSite (optional) The days on site.
     * @return The rental total.
     */
    getRentalTotal(rentalDays: number | undefined, rentalAmount: number | undefined, daysOnSite: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/GetRentalTotal?";
        if (rentalDays === null)
            throw new Error("The parameter 'rentalDays' cannot be null.");
        else if (rentalDays !== undefined)
            url_ += "rentalDays=" + encodeURIComponent("" + rentalDays) + "&";
        if (rentalAmount === null)
            throw new Error("The parameter 'rentalAmount' cannot be null.");
        else if (rentalAmount !== undefined)
            url_ += "rentalAmount=" + encodeURIComponent("" + rentalAmount) + "&";
        if (daysOnSite === null)
            throw new Error("The parameter 'daysOnSite' cannot be null.");
        else if (daysOnSite !== undefined)
            url_ += "daysOnSite=" + encodeURIComponent("" + daysOnSite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRentalTotal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRentalTotal(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetRentalTotal(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Actions containers.
     * @param agreementActionDto The agreement action.
     * @return The result.
     */
    actionContainers(agreementActionDto: AgreementActionDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/ActionContainers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agreementActionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionContainers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionContainers(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processActionContainers(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the agreement action.
     * @param customerId (optional) The customer identifier.
     * @param agreementNumber (optional) The agreement number.
     * @return The result.
     */
    addAgreementAction(customerId: string | undefined, agreementNumber: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/AddAgreementAction?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgreementAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgreementAction(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddAgreementAction(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the agreement actions.
     * @param request The request.
     * @return The result.
     */
    addAgreementActions(request: AddAgreementActionsRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/AddAgreementActions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgreementActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgreementActions(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddAgreementActions(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * ManualReset.
     * @param manualResetDto The manual reset.
     * @return The result.
     */
    manualReset(manualResetDto: ManualResetDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Agreements/ManualReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(manualResetDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManualReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManualReset(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processManualReset(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class AlertUrlService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    locationAdmin(locationId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/LocationAdmin/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationAdmin(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processLocationAdmin(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    rulesEngine(blackBoxId: string, date: number, highlightedDateTime: moment.Moment | null | undefined, highlightedMovementId: string | null | undefined, autoShowEventDetails: boolean | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/RulesEngine/{blackBoxId}/{date}?";
        if (blackBoxId === undefined || blackBoxId === null)
            throw new Error("The parameter 'blackBoxId' must be defined.");
        url_ = url_.replace("{blackBoxId}", encodeURIComponent("" + blackBoxId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (highlightedDateTime !== undefined && highlightedDateTime !== null)
            url_ += "highlightedDateTime=" + encodeURIComponent(highlightedDateTime ? "" + highlightedDateTime.toJSON() : "") + "&";
        if (highlightedMovementId !== undefined && highlightedMovementId !== null)
            url_ += "highlightedMovementId=" + encodeURIComponent("" + highlightedMovementId) + "&";
        if (autoShowEventDetails !== undefined && autoShowEventDetails !== null)
            url_ += "autoShowEventDetails=" + encodeURIComponent("" + autoShowEventDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRulesEngine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRulesEngine(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRulesEngine(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    assetBirthing(assetId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/AssetBirthing/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetBirthing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetBirthing(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAssetBirthing(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    assetEditing(assetId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/AssetEditing/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssetEditing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssetEditing(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAssetEditing(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    integrationAgreement(alertId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/IntegrationAgreement/{alertId}";
        if (alertId === undefined || alertId === null)
            throw new Error("The parameter 'alertId' must be defined.");
        url_ = url_.replace("{alertId}", encodeURIComponent("" + alertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntegrationAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntegrationAgreement(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processIntegrationAgreement(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    locationMatching(alertId: string, highlightedDateTime: moment.Moment | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/LocationMatching/{alertId}?";
        if (alertId === undefined || alertId === null)
            throw new Error("The parameter 'alertId' must be defined.");
        url_ = url_.replace("{alertId}", encodeURIComponent("" + alertId));
        if (highlightedDateTime !== undefined && highlightedDateTime !== null)
            url_ += "highlightedDateTime=" + encodeURIComponent(highlightedDateTime ? "" + highlightedDateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationMatching(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processLocationMatching(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    siteCheckInUrl(customerId: string | undefined, locationId: string, alertId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/SiteCheckInUrl/{alertId}/{locationId}?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (alertId === undefined || alertId === null)
            throw new Error("The parameter 'alertId' must be defined.");
        url_ = url_.replace("{alertId}", encodeURIComponent("" + alertId));
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSiteCheckInUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSiteCheckInUrl(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSiteCheckInUrl(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    yabbyMovements(assetId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/YabbyMovements/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processYabbyMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processYabbyMovements(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processYabbyMovements(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    missingContainerAlertToCustomer(alertId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/MissingContainerAlertToCustomer/{alertId}";
        if (alertId === undefined || alertId === null)
            throw new Error("The parameter 'alertId' must be defined.");
        url_ = url_.replace("{alertId}", encodeURIComponent("" + alertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMissingContainerAlertToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMissingContainerAlertToCustomer(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processMissingContainerAlertToCustomer(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    missingContainerMap(alertId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/MissingContainerMap/{alertId}";
        if (alertId === undefined || alertId === null)
            throw new Error("The parameter 'alertId' must be defined.");
        url_ = url_.replace("{alertId}", encodeURIComponent("" + alertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMissingContainerMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMissingContainerMap(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processMissingContainerMap(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    damageDetails(assetId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/AlertUrl/DamageDetails/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamageDetails(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDamageDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class AssetCheckInHistoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the name of the location.
     * @return The name of the location.
     */
    add(model: AddAssetCheckInHistoryRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/AssetCheckInHistory/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Gets the name of the location.
     * @return The name of the location.
     */
    updateWorkOrderStatus(model: UpdateWorkOrderStatusRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/AssetCheckInHistory/UpdateWorkOrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkOrderStatus(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateWorkOrderStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Gets the name of the location.
     * @return The name of the location.
     */
    assignWorkToExistingContainer(model: AssignWorkToExistingRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/AssetCheckInHistory/AssignWorkToExistingContainer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignWorkToExistingContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignWorkToExistingContainer(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAssignWorkToExistingContainer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class AssetService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds the asset.
     * @param assetId (optional) The asset identifier.
     * @param beaconMac (optional) The beacon MAC Address.
     * @param beaconName (optional) Name of the beacon.
     * @param lokaId (optional) The loka identifier.
     * @param type (optional) The asset type.
     * @param customerName (optional) Name of the customer.
     * @param colour (optional) The colour of the asset.
     * @param yearOfManufacturing (optional) The year of manufacturing.
     * @param side (optional) The type of side of the asset.
     * @return Ok result if successfully added asset.
     */
    addAsset(assetId: string | null | undefined, beaconMac: string | null | undefined, beaconName: string | null | undefined, lokaId: string | null | undefined, type: string | null | undefined, customerName: string | null | undefined, colour: string | null | undefined, yearOfManufacturing: string | null | undefined, side: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Asset/addAsset?";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (beaconMac !== undefined && beaconMac !== null)
            url_ += "beaconMac=" + encodeURIComponent("" + beaconMac) + "&";
        if (beaconName !== undefined && beaconName !== null)
            url_ += "beaconName=" + encodeURIComponent("" + beaconName) + "&";
        if (lokaId !== undefined && lokaId !== null)
            url_ += "lokaId=" + encodeURIComponent("" + lokaId) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (colour !== undefined && colour !== null)
            url_ += "colour=" + encodeURIComponent("" + colour) + "&";
        if (yearOfManufacturing !== undefined && yearOfManufacturing !== null)
            url_ += "yearOfManufacturing=" + encodeURIComponent("" + yearOfManufacturing) + "&";
        if (side !== undefined && side !== null)
            url_ += "side=" + encodeURIComponent("" + side) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAsset(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddAsset(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets the depot.
     * @param assetId (optional) The asset identifier.
     * @return The depot.
     */
    getDepot(assetId: string | null | undefined): Observable<DepotDto> {
        let url_ = this.baseUrl + "/api/Asset/GetDepot?";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepot(<any>response_);
                } catch (e) {
                    return <Observable<DepotDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepotDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDepot(response: HttpResponseBase): Observable<DepotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DepotDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepotDto>(<any>null);
    }
}

@Injectable()
export class AssetDamageService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the damage.
     * @param customerId (optional) The customer identifier.
     * @param locationId (optional) The location identifier.
     * @param assetTypeClassification (optional) The asset type classification.
     * @return An ActionResult.
     */
    getDamage(customerId: string | undefined, locationId: string | null | undefined, assetTypeClassification: AssetTypeClassification | undefined): Observable<AssetDamageHistoryDto[]> {
        let url_ = this.baseUrl + "/api/AssetDamage/GetDamage?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "assetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamage(<any>response_);
                } catch (e) {
                    return <Observable<AssetDamageHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssetDamageHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDamage(response: HttpResponseBase): Observable<AssetDamageHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AssetDamageHistoryDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDamageHistoryDto[]>(<any>null);
    }
}

@Injectable()
export class AssetDeviceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds the asset device.
     * @param assetId (optional) The asset identifier.
     * @param assetDeviceBirthingLocation (optional) The asset device location.
     * @param identifier (optional) The identifier.
     * @param deviceType (optional) The device type.
     * @return Ok result if successfully added asset device.
     */
    addAssetDevice(assetId: string | null | undefined, assetDeviceBirthingLocation: string | null | undefined, identifier: string | null | undefined, deviceType: DeviceType | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AssetDevice/addAssetDevice?";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (assetDeviceBirthingLocation !== undefined && assetDeviceBirthingLocation !== null)
            url_ += "assetDeviceBirthingLocation=" + encodeURIComponent("" + assetDeviceBirthingLocation) + "&";
        if (identifier !== undefined && identifier !== null)
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        if (deviceType === null)
            throw new Error("The parameter 'deviceType' cannot be null.");
        else if (deviceType !== undefined)
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAssetDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAssetDevice(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddAssetDevice(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets the latest positions.
     * @param customerId (optional) The customer identifier.
     * @return A ActionResult.
     */
    getLatestPositions(customerId: string | null | undefined): Observable<AssetDevicePositionUpdateDto[]> {
        let url_ = this.baseUrl + "/api/AssetDevice/GetLatestPositions?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestPositions(<any>response_);
                } catch (e) {
                    return <Observable<AssetDevicePositionUpdateDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssetDevicePositionUpdateDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestPositions(response: HttpResponseBase): Observable<AssetDevicePositionUpdateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AssetDevicePositionUpdateDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDevicePositionUpdateDto[]>(<any>null);
    }

    /**
     * Gets the latest positions.
     * @param alertUniqueId (optional) The alert unique identifier.
     * @return A ActionResult.
     */
    getAlertLatestPositions(alertUniqueId: string | undefined): Observable<PageListDtoOfAssetDevicePositionUpdateDto> {
        let url_ = this.baseUrl + "/api/AssetDevice/GetAlertLatestPositions?";
        if (alertUniqueId === null)
            throw new Error("The parameter 'alertUniqueId' cannot be null.");
        else if (alertUniqueId !== undefined)
            url_ += "alertUniqueId=" + encodeURIComponent("" + alertUniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlertLatestPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlertLatestPositions(<any>response_);
                } catch (e) {
                    return <Observable<PageListDtoOfAssetDevicePositionUpdateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageListDtoOfAssetDevicePositionUpdateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAlertLatestPositions(response: HttpResponseBase): Observable<PageListDtoOfAssetDevicePositionUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PageListDtoOfAssetDevicePositionUpdateDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageListDtoOfAssetDevicePositionUpdateDto>(<any>null);
    }

    /**
     * Gets the latest positions.
     * @param customerId (optional) The customer identifier.
     * @return A ActionResult.
     */
    getAssetPositionsVersusMovement(customerId: string | null | undefined): Observable<AssetDeviceVersusMovementDto[]> {
        let url_ = this.baseUrl + "/api/AssetDevice/GetAssetPositionsVersusMovement?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetPositionsVersusMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetPositionsVersusMovement(<any>response_);
                } catch (e) {
                    return <Observable<AssetDeviceVersusMovementDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AssetDeviceVersusMovementDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetPositionsVersusMovement(response: HttpResponseBase): Observable<AssetDeviceVersusMovementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AssetDeviceVersusMovementDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDeviceVersusMovementDto[]>(<any>null);
    }

    /**
     * Gets the devices export.
     * @param customerId (optional) The customer identifier.
     * @return A file result.
     */
    getDevicesExport(customerId: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/AssetDevice/GetDevicesExport?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicesExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDevicesExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Gets the devices export.
     * @return A file result.
     */
    addNote(model: AddBatteryTrackerNoteRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/AssetDevice/AddNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNote(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Gets the latest positions.
     * @param customerId (optional) The customer identifier.
     * @param assetId (optional) 
     * @param pageNo (optional) 
     * @param pageSize (optional) 
     * @return A ActionResult.
     */
    getAssetPositions(customerId: string | null | undefined, assetId: string | null | undefined, pageNo: number | undefined, pageSize: number | undefined): Observable<PagedListBaseModelOfAssetDevicePositionUpdateDto> {
        let url_ = this.baseUrl + "/api/AssetDevice/GetAssetPositions?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetPositions(<any>response_);
                } catch (e) {
                    return <Observable<PagedListBaseModelOfAssetDevicePositionUpdateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListBaseModelOfAssetDevicePositionUpdateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssetPositions(response: HttpResponseBase): Observable<PagedListBaseModelOfAssetDevicePositionUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListBaseModelOfAssetDevicePositionUpdateDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedListBaseModelOfAssetDevicePositionUpdateDto>(<any>null);
    }
}

@Injectable()
export class AssetLocationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all the assets from the Database.
     * @param customerId (optional) Customer id.
     * @return Ok Result with all the Assets.
     */
    getCustomer(customerId: string | undefined): Observable<CustomerAssetLocationModel> {
        let url_ = this.baseUrl + "/api/AssetLocation/GetCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAssetLocationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAssetLocationModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<CustomerAssetLocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerAssetLocationModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAssetLocationModel>(<any>null);
    }

    /**
     * Gets all customer asset types.
     * @param customerId (optional) The customer identifier.
     * @return A list of asset type names.
     */
    getAllAssetTypes(customerId: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/AssetLocation/GetCustomerAssetTypes?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssetTypes(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAssetTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }
}

@Injectable()
export class AssetLocationHistoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Exports the asset location history.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @param showAtRisk (optional) if set to true [show at risk].
     * @param showHighPriority (optional) if set to true [show high priority].
     * @param showMediumPriority (optional) if set to true [show medium priority].
     * @param showLowPriority (optional) if set to true [show low priority].
     * @param showNoPriority (optional) if set to true [show no priority].
     * @param cutoffDate (optional) The cutoff date.
     * @param showIncreased (optional) if set to true [show increased].
     * @param sortByDaysOnSite (optional) if set to true [sort by days on site].
     * @param assetTypeClassification (optional) The asset type classification.
     * @return An action result.
     */
    exportAssetLocationHistory(customerId: string | null | undefined, depotId: string | null | undefined, showAtRisk: boolean | undefined, showHighPriority: boolean | undefined, showMediumPriority: boolean | undefined, showLowPriority: boolean | undefined, showNoPriority: boolean | undefined, cutoffDate: moment.Moment | undefined, showIncreased: boolean | undefined, sortByDaysOnSite: boolean | undefined, assetTypeClassification: AssetTypeClassification | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ExportAssetLocationHistory?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (showAtRisk === null)
            throw new Error("The parameter 'showAtRisk' cannot be null.");
        else if (showAtRisk !== undefined)
            url_ += "showAtRisk=" + encodeURIComponent("" + showAtRisk) + "&";
        if (showHighPriority === null)
            throw new Error("The parameter 'showHighPriority' cannot be null.");
        else if (showHighPriority !== undefined)
            url_ += "showHighPriority=" + encodeURIComponent("" + showHighPriority) + "&";
        if (showMediumPriority === null)
            throw new Error("The parameter 'showMediumPriority' cannot be null.");
        else if (showMediumPriority !== undefined)
            url_ += "showMediumPriority=" + encodeURIComponent("" + showMediumPriority) + "&";
        if (showLowPriority === null)
            throw new Error("The parameter 'showLowPriority' cannot be null.");
        else if (showLowPriority !== undefined)
            url_ += "showLowPriority=" + encodeURIComponent("" + showLowPriority) + "&";
        if (showNoPriority === null)
            throw new Error("The parameter 'showNoPriority' cannot be null.");
        else if (showNoPriority !== undefined)
            url_ += "showNoPriority=" + encodeURIComponent("" + showNoPriority) + "&";
        if (cutoffDate === null)
            throw new Error("The parameter 'cutoffDate' cannot be null.");
        else if (cutoffDate !== undefined)
            url_ += "cutoffDate=" + encodeURIComponent(cutoffDate ? "" + cutoffDate.toJSON() : "") + "&";
        if (showIncreased === null)
            throw new Error("The parameter 'showIncreased' cannot be null.");
        else if (showIncreased !== undefined)
            url_ += "showIncreased=" + encodeURIComponent("" + showIncreased) + "&";
        if (sortByDaysOnSite === null)
            throw new Error("The parameter 'sortByDaysOnSite' cannot be null.");
        else if (sortByDaysOnSite !== undefined)
            url_ += "sortByDaysOnSite=" + encodeURIComponent("" + sortByDaysOnSite) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "assetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAssetLocationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAssetLocationHistory(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportAssetLocationHistory(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Resets the priority.
     * @param model The model.
     * @return An action result.
     */
    resetPriority(model: ResetPriorityRequestModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ResetPriority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPriority(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processResetPriority(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class BeaconScanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Posts the specified beacon scan body.
     * @param beaconScanBody The beacon scan body.
     * @return An OK Result if successful.
     */
    post(beaconScanBody: BeaconScanBodyDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BeaconScan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(beaconScanBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class BlackboxService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all.
     * @return A List of BlackboxDto.
     */
    getAll(): Observable<BlackboxDto[]> {
        let url_ = this.baseUrl + "/api/Blackbox/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<BlackboxDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BlackboxDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BlackboxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BlackboxDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BlackboxDto[]>(<any>null);
    }

    /**
     * Gets the active by customer.
     * @param customerId (optional) The customer identifier.
     * @return A List of active customer BlackboxDto.
     */
    getActiveByCustomer(customerId: string | undefined): Observable<BlackboxDto[]> {
        let url_ = this.baseUrl + "/api/Blackbox/GetActiveByCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveByCustomer(<any>response_);
                } catch (e) {
                    return <Observable<BlackboxDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BlackboxDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveByCustomer(response: HttpResponseBase): Observable<BlackboxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BlackboxDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BlackboxDto[]>(<any>null);
    }

    /**
     * Checks if the IMEI number exists.
     * @param imeiNumber (optional) The imei number.
     * @return True if the IMEI Number exists.
     */
    exists(imeiNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Blackbox/Exists?";
        if (imeiNumber !== undefined && imeiNumber !== null)
            url_ += "imeiNumber=" + encodeURIComponent("" + imeiNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Adds the blackbox.
     * @param addBlackboxDto The add blackbox dto.
     * @return A Task.
     */
    addBlackbox(addBlackboxDto: AddBlackboxDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blackbox/AddBlackbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addBlackboxDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBlackbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBlackbox(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddBlackbox(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Sets active.
     * @param blackbox The blackbox.
     * @return A Task.
     */
    setActive(blackbox: BlackboxDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blackbox/SetActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(blackbox);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetActive(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSetActive(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Sets active.
     * @param blackbox The blackbox.
     * @return A Task.
     */
    saveFaults(blackbox: BlackboxDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blackbox/SaveFaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(blackbox);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFaults(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSaveFaults(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Sets Passive.
     * @param blackbox The blackbox.
     * @return A Task.
     */
    setPassive(blackbox: BlackboxDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blackbox/SetPassive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(blackbox);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassive(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSetPassive(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Toggles Status.
     * @param blackbox The blackbox.
     * @return A Task.
     */
    toggleStatus(blackbox: ToggleBlackBoxStatusRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blackbox/ToggleStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(blackbox);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleStatus(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processToggleStatus(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class CacheBuilderService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Claears a cache key.
     * @param cacheKey (optional) The cache key.
     * @return An action result.
     */
    clearCacheByKey(cacheKey: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CacheBuilder/ClearCacheByKey?";
        if (cacheKey !== undefined && cacheKey !== null)
            url_ += "cacheKey=" + encodeURIComponent("" + cacheKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCacheByKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCacheByKey(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processClearCacheByKey(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets the cache entries.
     * @param searchTerm (optional) The search term.
     * @return An action result.
     */
    getCacheEntries(searchTerm: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CacheBuilder/GetCacheEntries?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCacheEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCacheEntries(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetCacheEntries(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class ContainerAssignmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Assigns the asset to the best matching agreement at the specified location.
     * @param request The request.
     * @return An action result.
     */
    assign(request: AssignAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssign(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAssign(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Changes the location.
     * @param request The request.
     * @return An action result.
     */
    changeLocation(request: AssignAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/ChangeLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLocation(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLocation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Changes the waste.
     * @param request The request.
     */
    changeWaste(request: AssignAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/ChangeWaste";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeWaste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeWaste(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processChangeWaste(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Ends the assignment.
     * @param request The request.
     * @return An action result.
     */
    endAssignment(request: AssignAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/EndAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndAssignment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processEndAssignment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Removes the agreement from the asset.
     * @param request The request.
     * @return An action result.
     */
    remove(request: AssignAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/Remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Copies the agreement from the asset.
     * @param request The request.
     * @return An action result.
     */
    copy(request: AssignAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/Copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    override(request: AssignAgreementRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/Override";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverride(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processOverride(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds a container assignment based on the specified job.
     * @param jobId (optional) The job identifier.
     * @param agreementNumber (optional) The agreement number.
     * @return An action result.
     */
    add(jobId: number | undefined, agreementNumber: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContainerAssignment/Add?";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class ContainerAvailabilityService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the container availability data.
     * @param customerId (optional) Gets or sets the customer identifier.
     * @param regionId (optional) Gets or sets the region identifier.
     * @param depotId (optional) Gets or sets the depot identifier.
     * @param locationId (optional) Gets or sets the location identifier.
     * @param containerStatus (optional) Gets or sets the container status.
     * @param containerAvailabilityShow (optional) Gets or sets the container availability show.
     * @param assetTypeClassification (optional) Gets or sets the asset type classification.
     * @param compareDate (optional) Gets or sets the compare date.
     * @param shouldSetDepotAvailability (optional) Gets or sets the should set depot availability.
     * @return An action result.
     */
    getContainerAvailability(customerId: string | undefined, regionId: string | null | undefined, depotId: string | null | undefined, locationId: string | null | undefined, containerStatus: ContainerStatus | null | undefined, containerAvailabilityShow: ContainerAvailabilityShow | undefined, assetTypeClassification: AssetTypeClassification | undefined, compareDate: moment.Moment | null | undefined, shouldSetDepotAvailability: boolean | undefined): Observable<ContainerAvailabilityResponse> {
        let url_ = this.baseUrl + "/api/ContainerAvailability/GetContainerAvailability?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "DepotId=" + encodeURIComponent("" + depotId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (containerStatus !== undefined && containerStatus !== null)
            url_ += "ContainerStatus=" + encodeURIComponent("" + containerStatus) + "&";
        if (containerAvailabilityShow === null)
            throw new Error("The parameter 'containerAvailabilityShow' cannot be null.");
        else if (containerAvailabilityShow !== undefined)
            url_ += "ContainerAvailabilityShow=" + encodeURIComponent("" + containerAvailabilityShow) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "AssetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        if (compareDate !== undefined && compareDate !== null)
            url_ += "CompareDate=" + encodeURIComponent(compareDate ? "" + compareDate.toJSON() : "") + "&";
        if (shouldSetDepotAvailability === null)
            throw new Error("The parameter 'shouldSetDepotAvailability' cannot be null.");
        else if (shouldSetDepotAvailability !== undefined)
            url_ += "ShouldSetDepotAvailability=" + encodeURIComponent("" + shouldSetDepotAvailability) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerAvailability(<any>response_);
                } catch (e) {
                    return <Observable<ContainerAvailabilityResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContainerAvailabilityResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetContainerAvailability(response: HttpResponseBase): Observable<ContainerAvailabilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ContainerAvailabilityResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContainerAvailabilityResponse>(<any>null);
    }
}

@Injectable()
export class CustomerClaimsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    addCustomerClaim(customerId: string, claimName: string | null | undefined, shouldBeAppliedAutomatically: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/useradmin/index/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (claimName !== undefined && claimName !== null)
            url_ += "claimName=" + encodeURIComponent("" + claimName) + "&";
        if (shouldBeAppliedAutomatically === null)
            throw new Error("The parameter 'shouldBeAppliedAutomatically' cannot be null.");
        else if (shouldBeAppliedAutomatically !== undefined)
            url_ += "shouldBeAppliedAutomatically=" + encodeURIComponent("" + shouldBeAppliedAutomatically) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerClaim(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerClaim(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class CustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    getAll(): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/Customer/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }
}

@Injectable()
export class CustomerDetailsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the customer details data.
     * @param customerId (optional) Gets or sets the customer identifier.
     * @param regionId (optional) Gets or sets the region identifier.
     * @param depotId (optional) Gets or sets the depot identifier.
     * @param locationId (optional) Gets or sets the location identifier.
     * @return An action result.
     */
    getCustomerDetails(customerId: string | undefined, regionId: string | null | undefined, depotId: string | null | undefined, locationId: string | null | undefined): Observable<CustomerDetailsResponse> {
        let url_ = this.baseUrl + "/api/CustomerDetails/GetCustomerDetails?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "DepotId=" + encodeURIComponent("" + depotId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerDetails(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDetailsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDetailsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerDetails(response: HttpResponseBase): Observable<CustomerDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDetailsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDetailsResponse>(<any>null);
    }
}

@Injectable()
export class CustomerSettingsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Indexes the specified customer identifier.
     * @param customerId (optional) The customer identifier.
     * @return A list of CustomerSettingDto
     */
    getCustomerUISettings(customerId: string | undefined): Observable<CustomerSettingDto[]> {
        let url_ = this.baseUrl + "/api/CustomerSettings/GetCustomerUISettings?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerUISettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerUISettings(<any>response_);
                } catch (e) {
                    return <Observable<CustomerSettingDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerSettingDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerUISettings(response: HttpResponseBase): Observable<CustomerSettingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerSettingDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerSettingDto[]>(<any>null);
    }
}

@Injectable()
export class DashboardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets live dashboard data.
     * @param request The request.
     * @return A LiveDashboardResponse.
     */
    getLiveDashBoardData(request: LiveDashboardRequest): Observable<LiveDashboardResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/Live";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiveDashBoardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiveDashBoardData(<any>response_);
                } catch (e) {
                    return <Observable<LiveDashboardResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LiveDashboardResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLiveDashBoardData(response: HttpResponseBase): Observable<LiveDashboardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LiveDashboardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LiveDashboardResponse>(<any>null);
    }

    /**
     * Gets the active dashboard data.
     * @param request The request parameters.
     * @return A ActiveDashboardResponse.
     */
    getActiveDashBoardData(request: ActiveDashboardRequest): Observable<ActiveDashboardResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/Active";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveDashBoardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveDashBoardData(<any>response_);
                } catch (e) {
                    return <Observable<ActiveDashboardResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActiveDashboardResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveDashBoardData(response: HttpResponseBase): Observable<ActiveDashboardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ActiveDashboardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveDashboardResponse>(<any>null);
    }

    /**
     * Gets the jobs from movements on day.
     * @param request The request.
     * @return A file result.
     */
    getJobsFromMovementsOnDay(request: ActiveDashboardRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/GetJobsFromMovementsOnDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobsFromMovementsOnDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobsFromMovementsOnDay(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobsFromMovementsOnDay(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Gets the customer services on date.
     * @param request The request.
     * @return A file result.
     */
    getCustomerServicesOnDate(request: ActiveDashboardRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/GetCustomerServicesOnDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerServicesOnDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerServicesOnDate(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerServicesOnDate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Gets the kpi data.
     * @param request The request model.
     * @return A KpiDataResponse.
     */
    getKPIData(request: KpiRequestModel): Observable<KpiDataResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/Kpi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKPIData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKPIData(<any>response_);
                } catch (e) {
                    return <Observable<KpiDataResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<KpiDataResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetKPIData(response: HttpResponseBase): Observable<KpiDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <KpiDataResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KpiDataResponse>(<any>null);
    }

    /**
     * Gets the kpi data export.
     * @param request The request.
     */
    getKPIDataExport(request: KpiRequestModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/KpiExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKPIDataExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKPIDataExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetKPIDataExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Gets the service information data.
     * @param request The request.
     */
    getServiceInformationData(request: LocationServiceRequest): Observable<LocationServiceResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/ServiceInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceInformationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceInformationData(<any>response_);
                } catch (e) {
                    return <Observable<LocationServiceResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationServiceResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceInformationData(response: HttpResponseBase): Observable<LocationServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LocationServiceResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationServiceResponse>(<any>null);
    }

    /**
     * Gets the kpi data.
     * @return A KpiDataResponse.
     */
    getServiceInformationDataExport(request: LocationServiceRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/ServiceInfoExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceInformationDataExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceInformationDataExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceInformationDataExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

@Injectable()
export class DataCorrectionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds beacon scans to blackbox.
     * @param model The model.
     * @return OK if completed.
     */
    addBeaconScans(model: AddBeaconScansRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/AddBeaconScans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBeaconScans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBeaconScans(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddBeaconScans(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Removes beacon scans to blackbox.
     * @param model The model.
     * @return OK if completed.
     */
    deleteBeaconScans(model: DeleteBeaconScansRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/DeleteBeaconScans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBeaconScans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBeaconScans(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBeaconScans(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Changes the beacon scan location.
     * @param model The model.
     * @return OK if completed.
     */
    changeBeaconScanLocation(model: ChangeBeaconScanLocationRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/ChangeBeaconScanLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeBeaconScanLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeBeaconScanLocation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processChangeBeaconScanLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Changes the rogue beacon scan location.
     * @param model The model.
     * @return OK if completed.
     */
    changeRogueBeaconScanLocation(model: ChangeRogueBeaconScanLocationRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/ChangeRogueBeaconScanLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeRogueBeaconScanLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRogueBeaconScanLocation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processChangeRogueBeaconScanLocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Updates the black box position.
     * @param model The model.
     * @return OK if completed.
     */
    updateBlackBoxPosition(model: UpdateBlackBoxPositionRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/UpdateBlackBoxPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBlackBoxPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBlackBoxPosition(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBlackBoxPosition(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Renames the asset.
     * @param model The model.
     * @return OK if completed.
     */
    renameAsset(model: RenameAssetRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/RenameAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameAsset(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRenameAsset(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Renames the blackbox.
     * @param model The model.
     * @return OK if completed.
     */
    renameBlackbox(model: RenameBlackboxRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/RenameBlackbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameBlackbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameBlackbox(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRenameBlackbox(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Changes the blackbox description.
     * @param model The model.
     * @return OK if completed.
     */
    changeBlackboxDescription(model: ChangeBlackboxDescriptionRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/DataCorrection/ChangeBlackboxDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeBlackboxDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeBlackboxDescription(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processChangeBlackboxDescription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class DemoCustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Sets the demo customer.
     * @param customerName (optional) Name of the customer.
     */
    setDemoCustomer(customerName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DemoCustomer/SetDemoCustomer?";
        if (customerName !== undefined && customerName !== null)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDemoCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDemoCustomer(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSetDemoCustomer(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class DepotService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the user depots.
     * @param customerId (optional) The customer identifier.
     * @return A list of DepotDto.
     */
    getUserDepots(customerId: string | null | undefined): Observable<DepotDto[]> {
        let url_ = this.baseUrl + "/api/Depot/GetUserDepots?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDepots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDepots(<any>response_);
                } catch (e) {
                    return <Observable<DepotDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepotDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDepots(response: HttpResponseBase): Observable<DepotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DepotDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepotDto[]>(<any>null);
    }

    /**
     * Gets the regions.
     * @param customerId (optional) The customer identifier.
     * @return A list of RegionDto.
     */
    getRegions(customerId: string | null | undefined): Observable<RegionDto[]> {
        let url_ = this.baseUrl + "/api/Depot/GetRegions?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegions(<any>response_);
                } catch (e) {
                    return <Observable<RegionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegions(response: HttpResponseBase): Observable<RegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionDto[]>(<any>null);
    }

    /**
     * Gets the customer depots.
     * @param customerId (optional) The customer identifier.
     * @return A list of DepotDto.
     */
    getCustomerDepots(customerId: string | null | undefined): Observable<DepotDto[]> {
        let url_ = this.baseUrl + "/api/Depot/GetCustomerDepots?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerDepots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerDepots(<any>response_);
                } catch (e) {
                    return <Observable<DepotDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DepotDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerDepots(response: HttpResponseBase): Observable<DepotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DepotDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepotDto[]>(<any>null);
    }

    /**
     * Gets the user location identifier.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @return The location identifier.
     */
    getUserLocationId(customerId: string | null | undefined, depotId: string | null | undefined): Observable<string | null> {
        let url_ = this.baseUrl + "/api/Depot/GetUserLocationId?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLocationId(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<string | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserLocationId(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string | null>(<any>null);
    }

    addLocation(depotName: string | null | undefined, companyName: string | null | undefined, isWasteTypeAllocationEnabled: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Depot/AddDepot?";
        if (depotName !== undefined && depotName !== null)
            url_ += "depotName=" + encodeURIComponent("" + depotName) + "&";
        if (companyName !== undefined && companyName !== null)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        if (isWasteTypeAllocationEnabled === null)
            throw new Error("The parameter 'isWasteTypeAllocationEnabled' cannot be null.");
        else if (isWasteTypeAllocationEnabled !== undefined)
            url_ += "isWasteTypeAllocationEnabled=" + encodeURIComponent("" + isWasteTypeAllocationEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLocation(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddLocation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class EmbedInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Returns Embed token, Embed URL, and Embed token expiry to the client.
     * @param customerId (optional) Customer id.
     * @param reportName (optional) The name of the requested report
     * @return JSON containing parameters for embedding.
     */
    getEmbedInfo(customerId: string | null | undefined, reportName: string | null | undefined): Observable<EmbedParams> {
        let url_ = this.baseUrl + "/api/EmbedInfo/GetEmbedInfo?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (reportName !== undefined && reportName !== null)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmbedInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmbedInfo(<any>response_);
                } catch (e) {
                    return <Observable<EmbedParams>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmbedParams>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmbedInfo(response: HttpResponseBase): Observable<EmbedParams> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EmbedParams>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmbedParams>(<any>null);
    }

    /**
     * A method to return the name of the most recently requested report (for analytics)
     * @return The most recently requested report
     */
    getReportName(): Observable<string> {
        let url_ = this.baseUrl + "/api/EmbedInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class FinanceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the billing details.
     * @param startDate (optional) Gets or sets the start date.
     * @param endDate (optional) Gets or sets the end date.
     * @param shouldAllowNullDates (optional) Gets or sets the should allow null dates.
     * @param shouldIncludeDeletions (optional) Gets or sets the should include deltions.
     * @return The billing details data.
     */
    getBillingDetails(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, shouldAllowNullDates: boolean | undefined, shouldIncludeDeletions: boolean | undefined): Observable<BillingDetailsData> {
        let url_ = this.baseUrl + "/api/Finance/BillingDetails?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (shouldAllowNullDates === null)
            throw new Error("The parameter 'shouldAllowNullDates' cannot be null.");
        else if (shouldAllowNullDates !== undefined)
            url_ += "ShouldAllowNullDates=" + encodeURIComponent("" + shouldAllowNullDates) + "&";
        if (shouldIncludeDeletions === null)
            throw new Error("The parameter 'shouldIncludeDeletions' cannot be null.");
        else if (shouldIncludeDeletions !== undefined)
            url_ += "ShouldIncludeDeletions=" + encodeURIComponent("" + shouldIncludeDeletions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDetails(<any>response_);
                } catch (e) {
                    return <Observable<BillingDetailsData>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillingDetailsData>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillingDetails(response: HttpResponseBase): Observable<BillingDetailsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BillingDetailsData>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillingDetailsData>(<any>null);
    }

    /**
     * Exports the billing details.
     * @param startDate (optional) Gets or sets the start date.
     * @param endDate (optional) Gets or sets the end date.
     * @param shouldAllowNullDates (optional) Gets or sets the should allow null dates.
     * @param shouldIncludeDeletions (optional) Gets or sets the should include deltions.
     * @return The export.
     */
    exportBillingDetails(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, shouldAllowNullDates: boolean | undefined, shouldIncludeDeletions: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Finance/ExportBillingDetails?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (shouldAllowNullDates === null)
            throw new Error("The parameter 'shouldAllowNullDates' cannot be null.");
        else if (shouldAllowNullDates !== undefined)
            url_ += "ShouldAllowNullDates=" + encodeURIComponent("" + shouldAllowNullDates) + "&";
        if (shouldIncludeDeletions === null)
            throw new Error("The parameter 'shouldIncludeDeletions' cannot be null.");
        else if (shouldIncludeDeletions !== undefined)
            url_ += "ShouldIncludeDeletions=" + encodeURIComponent("" + shouldIncludeDeletions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBillingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBillingDetails(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExportBillingDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Gets the billing summary.
     * @return The billing summary data.
     */
    getBillingSummary(): Observable<BillingSummaryData> {
        let url_ = this.baseUrl + "/api/Finance/BillingSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingSummary(<any>response_);
                } catch (e) {
                    return <Observable<BillingSummaryData>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillingSummaryData>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillingSummary(response: HttpResponseBase): Observable<BillingSummaryData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BillingSummaryData>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillingSummaryData>(<any>null);
    }

    /**
     * Exports the billing summary.
     * @return The export.
     */
    exportBillingSummary(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Finance/ExportBillingSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBillingSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBillingSummary(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExportBillingSummary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

@Injectable()
export class IngestionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    post(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Ingestion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class IntegrationMatchingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Searches for customer location.
     * @return A paged list  of services.
     */
    assign(model: AssignAgreementhViewModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Integration/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssign(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAssign(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class JobService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds the specified request.
     * @param request The request.
     * @return A 200 response if successful.
     */
    verify(request: VerifyJobRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Job/Verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processVerify(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets the jobs.
     * @param customerId (optional) The customer identifier.
     * @param locationId (optional) The location identifier.
     * @param depotId (optional) The depot identifier.
     * @param regionId (optional) The region identifier.
     * @param pageNo (optional) The page number.
     * @param pageSize (optional) The page size.
     * @return A JobsModel.
     */
    getJobs(customerId: string | undefined, locationId: string | null | undefined, depotId: string | null | undefined, regionId: string | null | undefined, pageNo: number | undefined, pageSize: number | undefined): Observable<JobsModel> {
        let url_ = this.baseUrl + "/api/Job/GetJobs?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobs(<any>response_);
                } catch (e) {
                    return <Observable<JobsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<JobsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobs(response: HttpResponseBase): Observable<JobsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <JobsModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobsModel>(<any>null);
    }
}

@Injectable()
export class LocationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the location containers.
     * @param customerId (optional) The customer identifier.
     * @param locationId (optional) The location identifier.
     * @return A LocationContainersModel.
     */
    getLocationContainers(customerId: string | undefined, locationId: string | undefined): Observable<LocationContainersModel> {
        let url_ = this.baseUrl + "/api/Location/GetLocationContainers?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationContainers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationContainers(<any>response_);
                } catch (e) {
                    return <Observable<LocationContainersModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationContainersModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationContainers(response: HttpResponseBase): Observable<LocationContainersModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LocationContainersModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationContainersModel>(<any>null);
    }

    /**
     * Adds the location.
     * @param locationName (optional) Name of the location.
     * @param latitude (optional) The latitude.
     * @param longitude (optional) The longitude.
     * @param companyName (optional) Name of the company.
     * @param depotName (optional) Name of the depot.
     * @param locationTypeName (optional) Name of the location type.
     * @param geofenceRadiusMetres (optional) The geofence radius metres.
     * @return An Ok Result if successful.
     */
    addLocation(locationName: string | null | undefined, latitude: number | undefined, longitude: number | undefined, companyName: string | null | undefined, depotName: string | null | undefined, locationTypeName: string | null | undefined, geofenceRadiusMetres: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Location/AddLocation?";
        if (locationName !== undefined && locationName !== null)
            url_ += "locationName=" + encodeURIComponent("" + locationName) + "&";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (companyName !== undefined && companyName !== null)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        if (depotName !== undefined && depotName !== null)
            url_ += "depotName=" + encodeURIComponent("" + depotName) + "&";
        if (locationTypeName !== undefined && locationTypeName !== null)
            url_ += "locationTypeName=" + encodeURIComponent("" + locationTypeName) + "&";
        if (geofenceRadiusMetres === null)
            throw new Error("The parameter 'geofenceRadiusMetres' cannot be null.");
        else if (geofenceRadiusMetres !== undefined)
            url_ += "geofenceRadiusMetres=" + encodeURIComponent("" + geofenceRadiusMetres) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLocation(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddLocation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the automatic gen location.
     * @param addAutoGenLocationDto The add automatic gen location dto.
     * @return An Ok Result if successful.
     */
    addAutoGenLocation(addAutoGenLocationDto: AddAutoGenLocationDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Location/AddAutoGenLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addAutoGenLocationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAutoGenLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAutoGenLocation(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddAutoGenLocation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Changes the geofence radius of a location.
     * @param locationName (optional) Name of the location.
     * @param geofenceRadiusMetres (optional) The geofence radius metres.
     * @return Ok result if successful.
     */
    changeGeofenceRadius(locationName: string | null | undefined, geofenceRadiusMetres: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Location/ChangeGeofenceRadius?";
        if (locationName !== undefined && locationName !== null)
            url_ += "locationName=" + encodeURIComponent("" + locationName) + "&";
        if (geofenceRadiusMetres === null)
            throw new Error("The parameter 'geofenceRadiusMetres' cannot be null.");
        else if (geofenceRadiusMetres !== undefined)
            url_ += "geofenceRadiusMetres=" + encodeURIComponent("" + geofenceRadiusMetres) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeGeofenceRadius(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeGeofenceRadius(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processChangeGeofenceRadius(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    find(model: LocationFindRequest): Observable<CustomerLocationPage> {
        let url_ = this.baseUrl + "/api/Location/Find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFind(<any>response_);
                } catch (e) {
                    return <Observable<CustomerLocationPage>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerLocationPage>><any>_observableThrow(response_);
        }));
    }

    protected processFind(response: HttpResponseBase): Observable<CustomerLocationPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerLocationPage>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLocationPage>(<any>null);
    }

    edit(model: EditLocationRequest): Observable<CustomerLocationPage> {
        let url_ = this.baseUrl + "/api/Location/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<CustomerLocationPage>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerLocationPage>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<CustomerLocationPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerLocationPage>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLocationPage>(<any>null);
    }

    merge(model: MergeLocationRequest): Observable<CustomerLocationPage> {
        let url_ = this.baseUrl + "/api/Location/Merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerge(<any>response_);
                } catch (e) {
                    return <Observable<CustomerLocationPage>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerLocationPage>><any>_observableThrow(response_);
        }));
    }

    protected processMerge(response: HttpResponseBase): Observable<CustomerLocationPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerLocationPage>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLocationPage>(<any>null);
    }

    /**
     * Searches for customer location.
     * @return A paged list  of services.
     */
    search(model: SimpleSearchViewModel): Observable<CustomerLocationPage> {
        let url_ = this.baseUrl + "/api/Location/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<CustomerLocationPage>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerLocationPage>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<CustomerLocationPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerLocationPage>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLocationPage>(<any>null);
    }

    /**
     * Updates the lat lon.
     * @param model The model.
     * @return A 200 response.
     */
    updateLatLon(model: UpdateGeoFenceViewModel): Observable<CustomerLocationPage> {
        let url_ = this.baseUrl + "/api/Location/UpdateLatLon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLatLon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLatLon(<any>response_);
                } catch (e) {
                    return <Observable<CustomerLocationPage>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerLocationPage>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLatLon(response: HttpResponseBase): Observable<CustomerLocationPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerLocationPage>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLocationPage>(<any>null);
    }

    /**
     * Gets the active by customer.
     * @param customerId (optional) The customer identifier.
     * @return A list of
     */
    getActiveByCustomer(customerId: string | undefined): Observable<CustomerLocationDto[]> {
        let url_ = this.baseUrl + "/api/Location/GetActiveByCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveByCustomer(<any>response_);
                } catch (e) {
                    return <Observable<CustomerLocationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerLocationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveByCustomer(response: HttpResponseBase): Observable<CustomerLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerLocationDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLocationDto[]>(<any>null);
    }
}

@Injectable()
export class LocationDetailsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the location details.
     * @param customerId (optional) The customer identifier.
     * @return A LocationDetailDto.
     */
    getLocations(customerId: string | null | undefined): Observable<CustomerLocationDto[]> {
        let url_ = this.baseUrl + "/api/LocationDetails/GetLocations?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocations(<any>response_);
                } catch (e) {
                    return <Observable<CustomerLocationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerLocationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocations(response: HttpResponseBase): Observable<CustomerLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerLocationDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLocationDto[]>(<any>null);
    }

    /**
     * Gets the location details.
     * @param locationId (optional) The location identifier.
     * @param customerId (optional) The customer identifier.
     * @param isDepotLocation (optional) 
     * @return A LocationDetailDto.
     */
    getLocationDetails(locationId: string | undefined, customerId: string | null | undefined, isDepotLocation: boolean | undefined): Observable<LocationDetailModel> {
        let url_ = this.baseUrl + "/api/LocationDetails/GetLocationDetails?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (isDepotLocation === null)
            throw new Error("The parameter 'isDepotLocation' cannot be null.");
        else if (isDepotLocation !== undefined)
            url_ += "isDepotLocation=" + encodeURIComponent("" + isDepotLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationDetails(<any>response_);
                } catch (e) {
                    return <Observable<LocationDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationDetails(response: HttpResponseBase): Observable<LocationDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LocationDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationDetailModel>(<any>null);
    }

    /**
     * Gets the location services.
     * @param request The request.
     * @return A paged list  of services.
     */
    getLocationServices(request: LocationDataRequest): Observable<LocationServicesPage> {
        let url_ = this.baseUrl + "/api/LocationDetails/GetLocationServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationServices(<any>response_);
                } catch (e) {
                    return <Observable<LocationServicesPage>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationServicesPage>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationServices(response: HttpResponseBase): Observable<LocationServicesPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LocationServicesPage>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationServicesPage>(<any>null);
    }

    /**
     * Gets the location journeys.
     * @param request The request.
     * @return A paged list  of services.
     */
    getLocationJourneys(request: LocationDataRequest): Observable<LocationJobsPage> {
        let url_ = this.baseUrl + "/api/LocationDetails/GetLocationJourneys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationJourneys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationJourneys(<any>response_);
                } catch (e) {
                    return <Observable<LocationJobsPage>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationJobsPage>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationJourneys(response: HttpResponseBase): Observable<LocationJobsPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LocationJobsPage>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationJobsPage>(<any>null);
    }

    /**
     * Gets the name of the location.
     * @return The name of the location.
     */
    getLocationName(geoPosition: GeoPosition): Observable<string> {
        let url_ = this.baseUrl + "/api/LocationDetails/GetLocationName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(geoPosition);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class LocationTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds the type of the location.
     * @param locationTypeName (optional) Name of the location type.
     * @return An Ok Result if successful.
     */
    addLocationType(locationTypeName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LocationType/AddLocationType?";
        if (locationTypeName !== undefined && locationTypeName !== null)
            url_ += "locationTypeName=" + encodeURIComponent("" + locationTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLocationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLocationType(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddLocationType(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class LokaScanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Posts the specified loka scan dto.
     * @param lokaScanDto The loka scan dto.
     * @return An ok if successful.
     */
    post(lokaScanDto: LokaScanDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LokaScan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lokaScanDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class MetaDataService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds the type of the meta data.
     * @param addMetaDataType Type of the add meta data.
     * @return Ok Result.
     */
    addMetaDataType(addMetaDataType: AddMetaDataTypeDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/MetaData/AddMetaDataType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addMetaDataType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMetaDataType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMetaDataType(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddMetaDataType(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets all the meta data types.
     * @return A List of Meta Data Types.
     */
    getAllTypes(): Observable<MetaDataTypeDto[]> {
        let url_ = this.baseUrl + "/api/MetaData/GetAllTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTypes(<any>response_);
                } catch (e) {
                    return <Observable<MetaDataTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetaDataTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTypes(response: HttpResponseBase): Observable<MetaDataTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MetaDataTypeDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetaDataTypeDto[]>(<any>null);
    }

    /**
     * Gets all the location records.
     * @return A List of Locations.
     */
    getAll(): Observable<MetaDataTypeDto[]> {
        let url_ = this.baseUrl + "/api/MetaData/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MetaDataTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetaDataTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MetaDataTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MetaDataTypeDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetaDataTypeDto[]>(<any>null);
    }
}

@Injectable()
export class MovementService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the location details.
     * @param movementId (optional) The movement identifier.
     * @param customerId (optional) The customer identifier.
     * @return A LocationDetailDto.
     */
    getMovementDetails(movementId: string | undefined, customerId: string | null | undefined): Observable<JourneyDetailModel> {
        let url_ = this.baseUrl + "/api/Movement/GetMovementDetails?";
        if (movementId === null)
            throw new Error("The parameter 'movementId' cannot be null.");
        else if (movementId !== undefined)
            url_ += "movementId=" + encodeURIComponent("" + movementId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMovementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMovementDetails(<any>response_);
                } catch (e) {
                    return <Observable<JourneyDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<JourneyDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMovementDetails(response: HttpResponseBase): Observable<JourneyDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <JourneyDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JourneyDetailModel>(<any>null);
    }

    /**
     * Adds the movement correction.
     * @param asset (optional) The asset.
     * @param fromLocationId (optional) Gets or sets from location identifier.
     * @param toLocationId (optional) Converts to locationid.
     * @param arrivedAt (optional) Gets or sets the arrived at.
     * @return An Ok Result if successful.
     */
    addMovementCorrection(asset: string | null | undefined, fromLocationId: string | null | undefined, toLocationId: string | null | undefined, arrivedAt: moment.Moment | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Movement/AddMovementCorrection?";
        if (asset !== undefined && asset !== null)
            url_ += "Asset=" + encodeURIComponent("" + asset) + "&";
        if (fromLocationId !== undefined && fromLocationId !== null)
            url_ += "FromLocationId=" + encodeURIComponent("" + fromLocationId) + "&";
        if (toLocationId !== undefined && toLocationId !== null)
            url_ += "ToLocationId=" + encodeURIComponent("" + toLocationId) + "&";
        if (arrivedAt !== undefined && arrivedAt !== null)
            url_ += "ArrivedAt=" + encodeURIComponent(arrivedAt ? "" + arrivedAt.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMovementCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMovementCorrection(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddMovementCorrection(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the movement correction.
     * @param addMovementCorrectionDto The add movement correction dto.
     * @return An Ok Result if successful.
     */
    addCorrectionFromBody(addMovementCorrectionDto: AddMovementCorrectionDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Movement/AddCorrection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addMovementCorrectionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCorrectionFromBody(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCorrectionFromBody(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddCorrectionFromBody(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the movement correction (and creates a container assignment).
     * @param addContainerCorrectionDto The container movement correction dto.
     * @return An Ok Result if successful.
     */
    addContainerCorrection(addContainerCorrectionDto: AddContainerCorrectionDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Movement/AddContainerCorrection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addContainerCorrectionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddContainerCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddContainerCorrection(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddContainerCorrection(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Saves the movement details.
     * @param saveMovementDetailsRequest The save movement details request.
     * @return An Ok Result if successful.
     */
    saveMovementDetails(saveMovementDetailsRequest: SaveMovementDetailsRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Movement/SaveMovementDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveMovementDetailsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMovementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMovementDetails(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSaveMovementDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class PositionUpdateApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    delete(model: DeletePositionRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/PositionUpdateApi/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }

    deletePositions(blackBoxId: string | undefined, startDateTime: moment.Moment | undefined, endDateTime: moment.Moment | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PositionUpdateApi/DeletePositions?";
        if (blackBoxId === null)
            throw new Error("The parameter 'blackBoxId' cannot be null.");
        else if (blackBoxId !== undefined)
            url_ += "blackBoxId=" + encodeURIComponent("" + blackBoxId) + "&";
        if (startDateTime === null)
            throw new Error("The parameter 'startDateTime' cannot be null.");
        else if (startDateTime !== undefined)
            url_ += "startDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toJSON() : "") + "&";
        if (endDateTime === null)
            throw new Error("The parameter 'endDateTime' cannot be null.");
        else if (endDateTime !== undefined)
            url_ += "endDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePositions(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePositions(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deleteDevicePositions(deviceId: number | undefined, startDateTime: moment.Moment | undefined, endDateTime: moment.Moment | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PositionUpdateApi/DeleteDevicePositions?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (startDateTime === null)
            throw new Error("The parameter 'startDateTime' cannot be null.");
        else if (startDateTime !== undefined)
            url_ += "startDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toJSON() : "") + "&";
        if (endDateTime === null)
            throw new Error("The parameter 'endDateTime' cannot be null.");
        else if (endDateTime !== undefined)
            url_ += "endDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDevicePositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDevicePositions(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDevicePositions(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    edit(model: EditPositionRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/PositionUpdateApi/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }
}

@Injectable()
export class ReportsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets the container availability report.
     * @param customerId (optional) Gets or sets the customer identifier.
     * @param regionId (optional) Gets or sets the region identifier.
     * @param depotId (optional) Gets or sets the depot identifier.
     * @param shouldBeSingleOperation (optional) Gets or sets the should be single operation.
     * @param locationId (optional) Gets or sets the location identifier.
     * @param assetTypeClassification (optional) Gets or sets the asset type classification.
     * @param fromDate (optional) Gets or sets the from date.
     * @param toDate (optional) Gets or sets the to date.
     * @param shouldTrackAssets (optional) Gets or sets the should track assets.
     * @param shouldCalculateLowTotals (optional) Gets or sets the should calculate low totals.
     * @param shouldPreloadJobs (optional) Gets or sets the should preload jobs.
     * @param shouldPreloadMovements (optional) Gets or sets the should preload movements.
     * @param shouldLoadAssetLocations (optional) Gets or sets the should load asset locations.
     * @return An action result.
     */
    getContainerAvailabilityReport(customerId: string | undefined, regionId: string | null | undefined, depotId: string[] | null | undefined, shouldBeSingleOperation: boolean | undefined, locationId: string | null | undefined, assetTypeClassification: AssetTypeClassification | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, shouldTrackAssets: boolean | undefined, shouldCalculateLowTotals: boolean | undefined, shouldPreloadJobs: boolean | undefined, shouldPreloadMovements: boolean | undefined, shouldLoadAssetLocations: boolean | undefined): Observable<ContainerAvailabilityReportData> {
        let url_ = this.baseUrl + "/api/Reports/ContainerAvailability?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (depotId !== undefined && depotId !== null)
            depotId && depotId.forEach(item => { url_ += "DepotId=" + encodeURIComponent("" + item) + "&"; });
        if (shouldBeSingleOperation === null)
            throw new Error("The parameter 'shouldBeSingleOperation' cannot be null.");
        else if (shouldBeSingleOperation !== undefined)
            url_ += "ShouldBeSingleOperation=" + encodeURIComponent("" + shouldBeSingleOperation) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "AssetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (shouldTrackAssets === null)
            throw new Error("The parameter 'shouldTrackAssets' cannot be null.");
        else if (shouldTrackAssets !== undefined)
            url_ += "ShouldTrackAssets=" + encodeURIComponent("" + shouldTrackAssets) + "&";
        if (shouldCalculateLowTotals === null)
            throw new Error("The parameter 'shouldCalculateLowTotals' cannot be null.");
        else if (shouldCalculateLowTotals !== undefined)
            url_ += "ShouldCalculateLowTotals=" + encodeURIComponent("" + shouldCalculateLowTotals) + "&";
        if (shouldPreloadJobs === null)
            throw new Error("The parameter 'shouldPreloadJobs' cannot be null.");
        else if (shouldPreloadJobs !== undefined)
            url_ += "ShouldPreloadJobs=" + encodeURIComponent("" + shouldPreloadJobs) + "&";
        if (shouldPreloadMovements === null)
            throw new Error("The parameter 'shouldPreloadMovements' cannot be null.");
        else if (shouldPreloadMovements !== undefined)
            url_ += "ShouldPreloadMovements=" + encodeURIComponent("" + shouldPreloadMovements) + "&";
        if (shouldLoadAssetLocations === null)
            throw new Error("The parameter 'shouldLoadAssetLocations' cannot be null.");
        else if (shouldLoadAssetLocations !== undefined)
            url_ += "ShouldLoadAssetLocations=" + encodeURIComponent("" + shouldLoadAssetLocations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerAvailabilityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerAvailabilityReport(<any>response_);
                } catch (e) {
                    return <Observable<ContainerAvailabilityReportData>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContainerAvailabilityReportData>><any>_observableThrow(response_);
        }));
    }

    protected processGetContainerAvailabilityReport(response: HttpResponseBase): Observable<ContainerAvailabilityReportData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ContainerAvailabilityReportData>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContainerAvailabilityReportData>(<any>null);
    }

    /**
     * Gets the collection containers.
     * @param customerId (optional) Gets or sets the customer identifier.
     * @param depotId (optional) Gets or sets the depot identifier.
     * @param userId (optional) Gets or sets the user identifier.
     * @param startDate (optional) Gets or sets the start date.
     * @param endDate (optional) Gets or sets the end date.
     * @param collectionsReportSortColumn (optional) Gets or sets the collections report sort column.
     * @param collectionsReportSortType (optional) Gets or sets the type of the collections report sort.
     * @return An action result.
     */
    getCollectionContainers(customerId: string | undefined, depotId: string | null | undefined, userId: string | null | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, collectionsReportSortColumn: CollectionsReportSortColumn | undefined, collectionsReportSortType: CollectionsReportSortType | undefined): Observable<CollectionContainerDto[]> {
        let url_ = this.baseUrl + "/api/Reports/CollectionContainers?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "DepotId=" + encodeURIComponent("" + depotId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (collectionsReportSortColumn === null)
            throw new Error("The parameter 'collectionsReportSortColumn' cannot be null.");
        else if (collectionsReportSortColumn !== undefined)
            url_ += "CollectionsReportSortColumn=" + encodeURIComponent("" + collectionsReportSortColumn) + "&";
        if (collectionsReportSortType === null)
            throw new Error("The parameter 'collectionsReportSortType' cannot be null.");
        else if (collectionsReportSortType !== undefined)
            url_ += "CollectionsReportSortType=" + encodeURIComponent("" + collectionsReportSortType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollectionContainers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollectionContainers(<any>response_);
                } catch (e) {
                    return <Observable<CollectionContainerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionContainerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCollectionContainers(response: HttpResponseBase): Observable<CollectionContainerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CollectionContainerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionContainerDto[]>(<any>null);
    }

    /**
     * Gets the collection users.
     * @param customerId (optional) The customer identifier.
     * @return An action result.
     */
    getCollectionUsers(customerId: string | undefined): Observable<CollectionUserDto[]> {
        let url_ = this.baseUrl + "/api/Reports/CollectionUsers?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollectionUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollectionUsers(<any>response_);
                } catch (e) {
                    return <Observable<CollectionUserDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionUserDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCollectionUsers(response: HttpResponseBase): Observable<CollectionUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CollectionUserDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionUserDto[]>(<any>null);
    }

    /**
     * Gets the integration report.
     * @param customerId (optional) Gets or sets the customer identifier.
     * @param depotId (optional) Gets or sets the depot identifier.
     * @param selectedDepotIds (optional) Gets or sets the selected depot identifiers.
     * @param assetTypeClassification (optional) Gets or sets the asset type classification.
     * @param integrationReportShowFilter (optional) Gets or sets the integration report show filter.
     * @param integrationReportOrderStatus (optional) Gets or sets the integration report order status.
     * @param integrationReportContainerStatus (optional) Gets or sets the integration report container status.
     * @param agreementsFromDate (optional) Gets or sets the agreements from date.
     * @param assetTypeId (optional) Gets or sets the asset type identifier.
     * @param agreementReference (optional) Gets or sets the agreement reference.
     * @param locationId (optional) Gets or sets the location identifier.
     * @param accountCode (optional) Gets or sets the account code.
     * @param accountManager (optional) Gets or sets the account manager.
     * @param accountCategory (optional) Gets or sets the account category.
     * @param accountType (optional) Gets or sets the account type.
     * @param customerName (optional) Gets or sets the name of the customer.
     * @param integrationReportSortColumn (optional) Gets or sets the integration report sort column.
     * @param integrationReportSortType (optional) Gets or sets the type of the integration report sort.
     * @param pageNo (optional) Gets or sets the page no.
     * @param pageSize (optional) Gets or sets the size of the page.
     * @return An action result.
     */
    getIntegrationReport(customerId: string | undefined, depotId: string | null | undefined, selectedDepotIds: string[] | null | undefined, assetTypeClassification: AssetTypeClassification | undefined, integrationReportShowFilter: IntegrationReportShowFilter | undefined, integrationReportOrderStatus: IntegrationReportOrderStatus | undefined, integrationReportContainerStatus: IntegrationReportContainerStatus | undefined, agreementsFromDate: moment.Moment | null | undefined, assetTypeId: number | null | undefined, agreementReference: string | null | undefined, locationId: string | null | undefined, accountCode: string | null | undefined, accountManager: string | null | undefined, accountCategory: string | null | undefined, accountType: string | null | undefined, customerName: string | null | undefined, integrationReportSortColumn: IntegrationReportSortColumn | undefined, integrationReportSortType: IntegrationReportSortType | undefined, pageNo: number | undefined, pageSize: number | undefined): Observable<IntegrationReportDataDto> {
        let url_ = this.baseUrl + "/api/Reports/Integration?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "DepotId=" + encodeURIComponent("" + depotId) + "&";
        if (selectedDepotIds !== undefined && selectedDepotIds !== null)
            selectedDepotIds && selectedDepotIds.forEach(item => { url_ += "SelectedDepotIds=" + encodeURIComponent("" + item) + "&"; });
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "AssetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        if (integrationReportShowFilter === null)
            throw new Error("The parameter 'integrationReportShowFilter' cannot be null.");
        else if (integrationReportShowFilter !== undefined)
            url_ += "IntegrationReportShowFilter=" + encodeURIComponent("" + integrationReportShowFilter) + "&";
        if (integrationReportOrderStatus === null)
            throw new Error("The parameter 'integrationReportOrderStatus' cannot be null.");
        else if (integrationReportOrderStatus !== undefined)
            url_ += "IntegrationReportOrderStatus=" + encodeURIComponent("" + integrationReportOrderStatus) + "&";
        if (integrationReportContainerStatus === null)
            throw new Error("The parameter 'integrationReportContainerStatus' cannot be null.");
        else if (integrationReportContainerStatus !== undefined)
            url_ += "IntegrationReportContainerStatus=" + encodeURIComponent("" + integrationReportContainerStatus) + "&";
        if (agreementsFromDate !== undefined && agreementsFromDate !== null)
            url_ += "AgreementsFromDate=" + encodeURIComponent(agreementsFromDate ? "" + agreementsFromDate.toJSON() : "") + "&";
        if (assetTypeId !== undefined && assetTypeId !== null)
            url_ += "AssetTypeId=" + encodeURIComponent("" + assetTypeId) + "&";
        if (agreementReference !== undefined && agreementReference !== null)
            url_ += "AgreementReference=" + encodeURIComponent("" + agreementReference) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (accountCode !== undefined && accountCode !== null)
            url_ += "AccountCode=" + encodeURIComponent("" + accountCode) + "&";
        if (accountManager !== undefined && accountManager !== null)
            url_ += "AccountManager=" + encodeURIComponent("" + accountManager) + "&";
        if (accountCategory !== undefined && accountCategory !== null)
            url_ += "AccountCategory=" + encodeURIComponent("" + accountCategory) + "&";
        if (accountType !== undefined && accountType !== null)
            url_ += "AccountType=" + encodeURIComponent("" + accountType) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (integrationReportSortColumn === null)
            throw new Error("The parameter 'integrationReportSortColumn' cannot be null.");
        else if (integrationReportSortColumn !== undefined)
            url_ += "IntegrationReportSortColumn=" + encodeURIComponent("" + integrationReportSortColumn) + "&";
        if (integrationReportSortType === null)
            throw new Error("The parameter 'integrationReportSortType' cannot be null.");
        else if (integrationReportSortType !== undefined)
            url_ += "IntegrationReportSortType=" + encodeURIComponent("" + integrationReportSortType) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "PageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationReport(<any>response_);
                } catch (e) {
                    return <Observable<IntegrationReportDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntegrationReportDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntegrationReport(response: HttpResponseBase): Observable<IntegrationReportDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IntegrationReportDataDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntegrationReportDataDto>(<any>null);
    }

    /**
     * Gets the agreement details.
     * @param depotId (optional) The depot identifier.
     * @param agreementReference (optional) The agreement reference.
     * @return An action result.
     */
    getAgreementDetails(depotId: string | undefined, agreementReference: string | null | undefined): Observable<IntegrationReportAgreementDetails> {
        let url_ = this.baseUrl + "/api/Reports/AgreementDetails?";
        if (depotId === null)
            throw new Error("The parameter 'depotId' cannot be null.");
        else if (depotId !== undefined)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (agreementReference !== undefined && agreementReference !== null)
            url_ += "agreementReference=" + encodeURIComponent("" + agreementReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementDetails(<any>response_);
                } catch (e) {
                    return <Observable<IntegrationReportAgreementDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntegrationReportAgreementDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgreementDetails(response: HttpResponseBase): Observable<IntegrationReportAgreementDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IntegrationReportAgreementDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntegrationReportAgreementDetails>(<any>null);
    }

    /**
     * Gets the assignments.
     * @param depotId (optional) The depot identifier.
     * @param agreementReference (optional) The agreement reference.
     * @return An action result.
     */
    getAssignments(depotId: string | undefined, agreementReference: string | null | undefined): Observable<IntegrationReportAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/Reports/Assignments?";
        if (depotId === null)
            throw new Error("The parameter 'depotId' cannot be null.");
        else if (depotId !== undefined)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (agreementReference !== undefined && agreementReference !== null)
            url_ += "agreementReference=" + encodeURIComponent("" + agreementReference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignments(<any>response_);
                } catch (e) {
                    return <Observable<IntegrationReportAssignmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntegrationReportAssignmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssignments(response: HttpResponseBase): Observable<IntegrationReportAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IntegrationReportAssignmentDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntegrationReportAssignmentDto[]>(<any>null);
    }

    /**
     * Exports the slow movers.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @param accountManager (optional) The account manager.
     * @param accountCode (optional) The account code.
     * @param accountCategory (optional) The account category.
     * @param accountType (optional) The account type.
     * @param customerName (optional) Name of the customer.
     * @param locationId (optional) The location identifier.
     * @param assetTypeClassification (optional) The asset type classification.
     * @return The export.
     */
    exportSlowMovers(customerId: string | undefined, depotId: string | null | undefined, accountManager: string | null | undefined, accountCode: string | null | undefined, accountCategory: string | null | undefined, accountType: string | null | undefined, customerName: string | null | undefined, locationId: string | null | undefined, assetTypeClassification: AssetTypeClassification | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/ExportSlowMovers?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (accountManager !== undefined && accountManager !== null)
            url_ += "accountManager=" + encodeURIComponent("" + accountManager) + "&";
        if (accountCode !== undefined && accountCode !== null)
            url_ += "accountCode=" + encodeURIComponent("" + accountCode) + "&";
        if (accountCategory !== undefined && accountCategory !== null)
            url_ += "accountCategory=" + encodeURIComponent("" + accountCategory) + "&";
        if (accountType !== undefined && accountType !== null)
            url_ += "accountType=" + encodeURIComponent("" + accountType) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "assetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSlowMovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSlowMovers(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExportSlowMovers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Exports the containers on site.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @param accountManager (optional) The account manager.
     * @param accountCode (optional) The account code.
     * @param accountCategory (optional) The account category.
     * @param customerName (optional) Name of the customer.
     * @param locationId (optional) The location identifier.
     * @param assetTypeClassification (optional) The asset type classification.
     * @return The export.
     */
    exportContainersOnSite(customerId: string | undefined, depotId: string | null | undefined, accountManager: string | null | undefined, accountCode: string | null | undefined, accountCategory: string | null | undefined, customerName: string | null | undefined, locationId: string | null | undefined, assetTypeClassification: AssetTypeClassification | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/ExportContainersOnSite?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (accountManager !== undefined && accountManager !== null)
            url_ += "accountManager=" + encodeURIComponent("" + accountManager) + "&";
        if (accountCode !== undefined && accountCode !== null)
            url_ += "accountCode=" + encodeURIComponent("" + accountCode) + "&";
        if (accountCategory !== undefined && accountCategory !== null)
            url_ += "accountCategory=" + encodeURIComponent("" + accountCategory) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "assetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportContainersOnSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportContainersOnSite(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExportContainersOnSite(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Gets efficiency report data.
     * @param customerId (optional) The customer identifier.
     * @param startDate (optional) The start date.
     * @param endDate (optional) The end date.
     * @param blackboxIds (optional) The blackbox identifiers
     * @return A EfficiencyReportDataResponse.
     */
    getEfficiencyReportData(customerId: string | null | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, blackboxIds: string[] | null | undefined): Observable<EfficiencyReportDataResponse> {
        let url_ = this.baseUrl + "/api/Reports/Efficiency?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (blackboxIds !== undefined && blackboxIds !== null)
            blackboxIds && blackboxIds.forEach(item => { url_ += "blackboxIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfficiencyReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfficiencyReportData(<any>response_);
                } catch (e) {
                    return <Observable<EfficiencyReportDataResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<EfficiencyReportDataResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEfficiencyReportData(response: HttpResponseBase): Observable<EfficiencyReportDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EfficiencyReportDataResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EfficiencyReportDataResponse>(<any>null);
    }
}

@Injectable()
export class RulesTestingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Exports the container assignments.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @param showExceptionsOnly (optional) if set to true [show exceptions only].
     * @param showMatchedOnly (optional) The show matches only.
     * @param sortBy (optional) The sort by.
     * @param assetTypeClassification (optional) The asset type classification.
     * @return An action result.
     */
    exportContainerAssignments(customerId: string | null | undefined, depotId: string | null | undefined, showExceptionsOnly: boolean | undefined, showMatchedOnly: boolean | undefined, sortBy: AssignmentSort | undefined, assetTypeClassification: AssetTypeClassification | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ExportContainerAssignments?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (showExceptionsOnly === null)
            throw new Error("The parameter 'showExceptionsOnly' cannot be null.");
        else if (showExceptionsOnly !== undefined)
            url_ += "showExceptionsOnly=" + encodeURIComponent("" + showExceptionsOnly) + "&";
        if (showMatchedOnly === null)
            throw new Error("The parameter 'showMatchedOnly' cannot be null.");
        else if (showMatchedOnly !== undefined)
            url_ += "showMatchedOnly=" + encodeURIComponent("" + showMatchedOnly) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "assetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportContainerAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportContainerAssignments(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportContainerAssignments(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Exports the location agreements.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @param assetTypeClassification (optional) The asset type classification.
     * @return An action result.
     */
    exportLocationAgreements(customerId: string | null | undefined, depotId: string | null | undefined, assetTypeClassification: AssetTypeClassification | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ExportLocationAgreements?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "assetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLocationAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLocationAgreements(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportLocationAgreements(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Exports the agreement history.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @param assetTypeClassification (optional) The asset type classification.
     * @return An action result.
     */
    exportAgreementHistory(customerId: string | null | undefined, depotId: string | null | undefined, assetTypeClassification: AssetTypeClassification | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ExportAgreementHistory?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        if (assetTypeClassification === null)
            throw new Error("The parameter 'assetTypeClassification' cannot be null.");
        else if (assetTypeClassification !== undefined)
            url_ += "assetTypeClassification=" + encodeURIComponent("" + assetTypeClassification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAgreementHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAgreementHistory(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportAgreementHistory(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets the report data.
     * @param customerId (optional) The customer identifier.
     * @param locationIds (optional) The location ids.
     * @return An action result.
     */
    getReportData(customerId: string | null | undefined, locationIds: string[] | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/GetReportData?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "locationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportData(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportData(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class TestingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    test(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Testing/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    test2(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Testing/test2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest2(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTest2(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    test3(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Testing/test3";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest3(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTest3(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class UntrackedAssetService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Adds the specified request.
     * @param request The request.
     * @return A 200 response if successful.
     */
    add(request: AddUntrackedAssetRequest): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UntrackedAsset/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Adds the specified request.
     * @param movementIds (optional) The movement identifiers.
     * @return A 200 response if successful.
     */
    addRange(movementIds: string[] | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UntrackedAsset/AddRange?";
        if (movementIds !== undefined && movementIds !== null)
            movementIds && movementIds.forEach(item => { url_ += "movementIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRange(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddRange(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Gets all untracked assets for a list of movements.
     * @param movementIds The movement identifiers.
     * @return The untracked asset logs and locations.
     */
    getAll(movementIds: string[]): Observable<UntrackedAssetsDto> {
        let url_ = this.baseUrl + "/api/UntrackedAsset/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(movementIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UntrackedAssetsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UntrackedAssetsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UntrackedAssetsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UntrackedAssetsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UntrackedAssetsDto>(<any>null);
    }
}

@Injectable()
export class UserApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all.
     * @return A List of BlackboxDto.
     */
    getUser(): Observable<UserDetailsResponse> {
        let url_ = this.baseUrl + "/api/UserApi/GetUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDetailsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDetailsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDetailsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetailsResponse>(<any>null);
    }

    /**
     * Creates the customer user.
     * @param model The model.
     * @return Ok or Bad Request.
     */
    createCustomerUser(model: CreateUserModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserApi/CreateCustomerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCustomerUser(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Creates the customer damage operative user.
     * @param model The model.
     * @return Ok or Bad Request.
     */
    createCustomerDamageOperativeUser(model: CreateUserModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserApi/CreateCustomerDamageOperativeUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerDamageOperativeUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerDamageOperativeUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCustomerDamageOperativeUser(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Creates the customer user.
     * @param model The model.
     * @return Ok or Bad Request.
     */
    createCustomerRepairOperativeUser(model: CreateUserModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserApi/CreateCustomerRepairOperativeUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerRepairOperativeUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerRepairOperativeUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCustomerRepairOperativeUser(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Creates the customer user.
     * @param model The model.
     * @return Ok or Bad Request.
     */
    createCustomerAddDamageUser(model: CreateUserModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserApi/CreateCustomerAddDamageUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerAddDamageUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerAddDamageUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCustomerAddDamageUser(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    /**
     * Creates the customer user.
     * @param model The model.
     * @return Ok or Bad Request.
     */
    createFitterUser(model: CreateUserModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserApi/CreateFitterUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFitterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFitterUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFitterUser(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    resetFitterUserPassword(model: ResetUserPasswordModel): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserApi/ResetFitterUserPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetFitterUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetFitterUserPassword(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processResetFitterUserPassword(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable()
export class WasteTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all.
     * @return A List of WasteTypeDto.
     */
    getAll(): Observable<WasteTypeDto[]> {
        let url_ = this.baseUrl + "/api/WasteType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<WasteTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WasteTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WasteTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WasteTypeDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WasteTypeDto[]>(<any>null);
    }

    /**
     * Adds to location.
     * @param locationId (optional) The location identifier.
     * @param wasteTypeId (optional) The waste type identifier.
     * @param primaryWasteType (optional) if set to true [primary waste type].
     * @return A List of WasteTypeDto.
     */
    addToLocation(locationId: string | undefined, wasteTypeId: number | undefined, primaryWasteType: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WasteType/GetAll?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (wasteTypeId === null)
            throw new Error("The parameter 'wasteTypeId' cannot be null.");
        else if (wasteTypeId !== undefined)
            url_ += "wasteTypeId=" + encodeURIComponent("" + wasteTypeId) + "&";
        if (primaryWasteType === null)
            throw new Error("The parameter 'primaryWasteType' cannot be null.");
        else if (primaryWasteType !== undefined)
            url_ += "primaryWasteType=" + encodeURIComponent("" + primaryWasteType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddToLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddToLocation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddToLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WorkOrdersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    add(model: AddOrderRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/WorkOrdersApi/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    addFitterJob(model: AddFitterJobRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/WorkOrdersApi/AddFitterJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFitterJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFitterJob(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processAddFitterJob(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    updateWorkOrderStatus(model: UpdateWorkOrderStatusRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/WorkOrdersApi/UpdateWorkOrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkOrderStatus(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateWorkOrderStatus(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    addDeployment(model: AddDeploymentRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/WorkOrdersApi/AddDeployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDeployment(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processAddDeployment(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    toggleDeployment(model: ToggleDeploymentRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/WorkOrdersApi/ToggleDeployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleDeployment(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processToggleDeployment(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    move(model: MoveOrderRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/WorkOrdersApi/Move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMove(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processMove(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }

    /**
     * Gets all.
     * @return A List of CustomerDto.
     */
    sort(model: SortOrderRequestModel): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/WorkOrdersApi/Sort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSort(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processSort(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(<any>null);
    }
}

@Injectable()
export class WorkOrdersService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:14932";
    }

    /**
     * Exports the specified customer/depot.
     * @param customerId (optional) The customer identifier.
     * @param depotId (optional) The depot identifier.
     * @return An IActionResult.
     */
    export(customerId: string | null | undefined, depotId: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Export?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (depotId !== undefined && depotId !== null)
            url_ += "depotId=" + encodeURIComponent("" + depotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

/** Base model for paged lists. */
export interface PagedListBaseModelOfAlertDto {
    /** Gets the current page. */
    currentPage: number;
    /** Gets the total pages. */
    totalPages: number;
    /** Gets the size of the page. */
    pageSize: number;
    /** Gets the total total item count. */
    totalTotalItemCount: number;
    /** Gets a value indicating whether this instance has previous. */
    hasPrevious: boolean;
    /** Gets a value indicating whether this instance has next. */
    hasNext: boolean;
    /** Gets or sets the items. */
    items?: AlertDto[] | undefined;
}

/** Paged Admin Alert Response. */
export interface AdminAlertResponse extends PagedListBaseModelOfAlertDto {
    /** Gets the customers. */
    customers?: KeyValuePairOfGuidAndString[] | undefined;
    /** Gets the blackboxes. */
    blackboxes?: KeyValuePairOfGuidAndString[] | undefined;
    /** Gets the alert types. */
    alertTypes?: KeyValuePairOfIntegerAndString[] | undefined;
}

export interface KeyValuePairOfGuidAndString {
    key: string;
    value: string;
}

export interface KeyValuePairOfIntegerAndString {
    key: number;
    value: string;
}

/** Alert dto. */
export interface AlertDto {
    /** Gets or sets the identifier. */
    id: number;
    /** The alert identifier. */
    alertId?: number | undefined;
    /** The alert identifier. */
    alertDescription?: string | undefined;
    /** Gets or sets the created. */
    created: moment.Moment;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the details. */
    details?: string | undefined;
    /** Gets or sets the acknowledged identifier. */
    acknowledgedById?: string | undefined;
    /** Gets or sets the acknowledged by. */
    acknowledgedBy?: string | undefined;
    /** Gets or sets the alert URL. */
    alertUrl?: string | undefined;
    /** Gets or sets the priority identifier. */
    priorityId: number;
    /** Gets or sets the customer identifier. */
    customerId?: string | undefined;
    /** Gets or sets the customer. */
    customerName?: string | undefined;
    /** Gets or sets the closed by identifier. */
    closedById?: string | undefined;
    /** Gets or sets the acknowledged by. */
    closedBy?: string | undefined;
    /** Alert Status. */
    alertStatus: AlertStatus;
    /** Gets or sets the alert key. */
    alertKey?: string | undefined;
    /** Gets or sets the relevant identifier. */
    relevantId?: string | undefined;
    /** Gets or sets the blackbox identifier. */
    blackboxId?: string | undefined;
    /** Gets or sets the name of the blackbox. */
    blackboxName?: string | undefined;
    /** Gets or sets the action URL. */
    actionUrl?: string | undefined;
    /** Gets or sets the action confirm text. */
    actionConfirmText?: string | undefined;
    /** Gets or sets the action descrption. */
    actionDescription?: string | undefined;
    /** Gets or sets a value indicating whether this instance is action prompt required. */
    isActionPromptRequired: boolean;
    /** Gets or sets the unique identifier. */
    uniqueId?: string | undefined;
    /** Gets or sets the blackbox date time. */
    blackboxDateTime?: moment.Moment | undefined;
}

/** Alert Status. */
export enum AlertStatus {
    InProgress = 0,
    OnHold = 1,
    Closed = 2,
    PendingConfirmation = 3,
}

/** Alert request. */
export interface AdminAlertRequest {
    /** Gets or sets the status. */
    status?: number[] | undefined;
    /** Gets or sets the customer ids. */
    customerIds?: string[] | undefined;
    /** Gets or sets the alert type ids. */
    alertTypeIds?: number[] | undefined;
    /** Gets or sets the alerts to acknowledge. */
    alertsToAcknowledge?: number[] | undefined;
    /** Gets or sets the alerts to close. */
    alertsToClose?: number[] | undefined;
    /** Gets or sets the blackbox ids. */
    blackboxIds?: string[] | undefined;
    /** Gets or sets the size of the page. */
    pageSize: number;
    /** Gets or sets the page identifier. */
    pageId: number;
    /** Gets or sets a value indicating whether this instance is sort decending. */
    isSortDecending: boolean;
    /** Gets or sets the order by. */
    orderBy?: string | undefined;
    /** Gets or sets the data changed. */
    dataChanged?: boolean | undefined;
    /** Gets or sets the other changed. */
    otherChanged?: boolean | undefined;
}

/** Close alert request model. */
export interface CloseAlertRequest {
    /** Gets the alert identifier. */
    alertId: number;
    /** Gets or sets the data changed. */
    dataChanged?: boolean | undefined;
    /** Gets or sets the other changed. */
    otherChanged?: boolean | undefined;
}

export interface UpdateAdminUserCustomersModel {
    /** Gets or sets the customer ids. */
    customerIds?: string[] | undefined;
    /** Gets or sets the user identifier. */
    userId: string;
}

/** AddAgreementRequest. */
export interface AddAgreementRequest {
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the agreement number. */
    agreementNumber?: string | undefined;
    /** Gets or sets the asset type identifier. */
    assetTypeId: number;
    /** Gets or sets the waste type identifier. */
    wasteTypeId: number;
    /** Gets or sets the start date. */
    startDate?: moment.Moment | undefined;
    /** Gets or sets the account manager. */
    accountManager?: string | undefined;
    /** Gets or sets the account number. */
    accountCode?: string | undefined;
    /** Gets or sets the account category. */
    accountCategory?: string | undefined;
    /** Gets or sets the name of the site customer. */
    siteCustomerName?: string | undefined;
}

/** AddAgreementRentalAmountsResponse. */
export interface AddAgreementRentalAmountsResponse {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the agreements. */
    agreements?: IntegrationReportAgreementDto[] | undefined;
    /** Gets or sets a value indicating whether this instance is any rent. */
    isAnyRent: boolean;
    /** Gets or sets the this week rent. */
    thisWeekRent: number;
    /** Gets or sets the this week rent display. */
    thisWeekRentDisplay?: string | undefined;
    /** Gets or sets the total rent. */
    totalRent: number;
    /** Gets the total rent display. */
    totalRentDisplay?: string | undefined;
}

/** IntegrationReportAgreementDto. */
export interface IntegrationReportAgreementDto {
    /** Gets or sets the reference. */
    reference?: string | undefined;
    /** ContactEmail. */
    contactEmail?: string | undefined;
    /** ContactName. */
    contactName?: string | undefined;
    /** ContactNumber. */
    contactNumber?: string | undefined;
    /** Notes. */
    notes?: string | undefined;
    /** Gets or sets a value indicating whether the agreement is checked. */
    checked: boolean;
    /** Gets or sets the start date. */
    startDate: moment.Moment;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the name of the location. */
    locationName?: string | undefined;
    /** Gets or sets the account category. */
    accountCategory?: string | undefined;
    /** Gets or sets the account code. */
    accountCode?: string | undefined;
    /** Gets or sets the account manager. */
    accountManager?: string | undefined;
    /** Gets or sets the account type. */
    accountType?: string | undefined;
    /** Gets or sets the name of the customer. */
    customerName?: string | undefined;
    /** Gets or sets the is actioned. */
    isActioned?: boolean | undefined;
    /** Gets or sets the latest action date. */
    latestActionDate?: moment.Moment | undefined;
    /** Gets or sets the latest action date display. */
    latestActionDateDisplay?: string | undefined;
    /** Gets or sets the latest action description. */
    latestActionDescription?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the asset type identifier. */
    assetTypeId?: number | undefined;
    /** Gets or sets the name of the asset type. */
    assetTypeName?: string | undefined;
    /** Gets or sets the waste type identifier. */
    wasteTypeId?: number | undefined;
    /** Gets or sets the name of the waste type. */
    wasteTypeName?: string | undefined;
    /** Gets or sets the service frequency. */
    serviceFrequency?: number | undefined;
    /** Gets the service frequency display. */
    serviceFrequencyDisplay?: string | undefined;
    /** Gets the qty. */
    qty?: number | undefined;
    /** Gets or sets the rental amount. */
    rentalAmount: number;
    /** Gets or sets the rental amount display. */
    rentalAmountDisplay?: string | undefined;
    /** Gets the rental total. */
    rentalTotal: number;
    /** Gets the rental total display. */
    rentalTotalDisplay?: string | undefined;
    /** Gets or sets a value indicating whether this instance is custom rental. */
    isCustomRental: boolean;
    /** Gets or sets the containers. */
    containers?: IntegrationReportContainerDto[] | undefined;
    /** Gets or sets the retrieved assignments. */
    retrievedAssignments?: IntegrationReportAssignmentDto[] | undefined;
    /** Gets or sets the has notes. */
    hasNotes: boolean;
}

/** Asset type classification. */
export enum AssetTypeClassification {
    RoRo = 0,
    Skip = 1,
    All = 2,
}

/** IntegrationReportContainerDto. */
export interface IntegrationReportContainerDto {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the asset type identifier. */
    assetTypeId?: number | undefined;
    /** Gets or sets the name of the asset type. */
    assetTypeName?: string | undefined;
    /** Gets or sets the waste type identifier. */
    wasteTypeId?: number | undefined;
    /** Gets or sets the name of the waste type. */
    wasteTypeName?: string | undefined;
    /** Gets or sets the start date. */
    startDate: moment.Moment;
    /** Gets or sets the end date. */
    endDate?: moment.Moment | undefined;
    /** Gets or sets the days on site. */
    daysOnSite: number;
    /** Gets the days on site display. */
    daysOnSiteDisplay?: string | undefined;
    /** Gets or sets the status. */
    status: IntegrationReportContainerStatus;
    /** Gets or sets the rental total. */
    rentalTotal: number;
}

/** IntegrationReportStatus. */
export enum IntegrationReportContainerStatus {
    None = 0,
    DifferentContainerSize = 1,
    DifferentContainerType = 2,
    DifferentWaste = 3,
    Matched = 4,
    NotMatched = 5,
}

/** IntegrationReportAssignmentDto. */
export interface IntegrationReportAssignmentDto {
    /** Gets or sets the container in. */
    containerIn?: string | undefined;
    /** Gets or sets the container out. */
    containerOut?: string | undefined;
    /** Gets or sets the created date. */
    created: moment.Moment;
    /** Gets or sets the start date. */
    startDate: moment.Moment;
    /** Gets or sets the end date. */
    endDate?: moment.Moment | undefined;
    /** Gets or sets the name of the job type. */
    jobTypeName?: string | undefined;
    /** Gets or sets the name of the job type. */
    jobTypeNameDisplay?: string | undefined;
    /** Gets or sets the days on site. */
    daysOnSite?: number | undefined;
    /** Gets the days on site display. */
    daysOnSiteDisplay?: string | undefined;
    /** Gets the other reference. */
    otherReference?: string | undefined;
    /** Gets the other date time. */
    otherDateTime?: moment.Moment | undefined;
}

/** AddAgreementRentalAmountsRequest. */
export interface AddAgreementRentalAmountsRequest {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the rental amounts. */
    rentalAmounts?: AgreementRentalAmountDto[] | undefined;
    /** Gets or sets the agreements. */
    agreements?: IntegrationReportAgreementDto[] | undefined;
    /** Gets or sets the rental days. */
    rentalDays: number;
}

/** AgreementRentalAmountDto. */
export interface AgreementRentalAmountDto {
    /** Gets or sets the external reference. */
    externalReference?: string | undefined;
    /** Gets or sets the rental amount. */
    rentalAmount: number;
    /** Gets or sets a value indicating whether this instance is custom rental. */
    isCustomRental: boolean;
    /** Gets or sets the customer identifier. */
    customerId: string;
}

/** AgreementActionDto. */
export interface AgreementActionDto {
    /** Gets or sets the external reference. */
    externalReference?: string | undefined;
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets is scheduled. */
    isScheduled?: boolean | undefined;
    /** Gets or sets the last action description. */
    lastActionDescription?: string | undefined;
    /** Gets or sets the last action date. */
    lastActionDate?: moment.Moment | undefined;
    /** Gets or sets the containers. */
    containers?: AgreementActionContainerDto[] | undefined;
}

/** AgreementActionContainerDto. */
export interface AgreementActionContainerDto {
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
    /** Gets or sets the days on site. */
    daysOnSite: number;
}

/** AddAgreementActionsRequest. */
export interface AddAgreementActionsRequest {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the agreement actions. */
    agreementActions?: AgreementActionDto[] | undefined;
    /** Gets or sets the agreements. */
    agreements?: IntegrationReportAgreementDto[] | undefined;
}

/** ManualResetDto. */
export interface ManualResetDto {
    /** Gets or sets the external reference. */
    externalReference?: string | undefined;
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the containers. */
    containers?: ManualResetContainerDto[] | undefined;
}

/** ManualResetContainerDto. */
export interface ManualResetContainerDto {
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
    /** Gets or sets the days on site. */
    daysOnSite: number;
    /** Gets or sets the start date. */
    startDate: moment.Moment;
    /** Gets or sets the reset date. */
    resetDate: moment.Moment;
}

/** Add Asset CheckIn History Request. */
export interface AddAssetCheckInHistoryRequest {
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the asset on stite status. */
    assetOnSiteStatus: AssetOnSiteStatus;
}

/** Asset on Site Status. */
export enum AssetOnSiteStatus {
    None = 0,
    AssetOnSite = 1,
    AssetNotOnSite = 2,
    CorrectionMovementAdded = 3,
    AssetBirthed = 4,
    AssetModified = 5,
}

/** Add Asset CheckIn History Request. */
export interface UpdateWorkOrderStatusRequest {
    /** Gets or sets the asset identifier. */
    workOrderId: number;
    /** Gets or sets the location identifier. */
    status: WorkOrderStatus;
}

/** Work order Status. */
export enum WorkOrderStatus {
    None = 0,
    DeniedAccesToSite = 1,
    NoContainerOnSite = 2,
    HasOrderFulfilled = 3,
    HasOrderWrongWasteType = 4,
    SiteNotFound = 5,
    HasWrongContainerType = 6,
    HasWrongContainerTypeAndWrongWasteType = 7,
    OrderNotFound = 8,
    FitterNotFound = 9,
    HasWrongQuantity = 10,
    NotMatched = 11,
    Complete = 12,
    BeaconReplaced = 13,
    BatteryTrackerReplaced = 14,
}

/** Add Asset To Existing Work Order Request. */
export interface AssignWorkToExistingRequest {
    /** Gets or sets the asset identifier. */
    workOrderId: number;
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
    /** Gets the location identifier. */
    locationId: string;
}

/** Depot dto. */
export interface DepotDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is waste type allocation enabled. */
    isWasteTypeAllocationEnabled: boolean;
    /** Gets or sets a value indicating whether this instance is required quantities enabled. */
    isRequiredQuantitiesEnabled: boolean;
    /** Gets or sets a value indicating whether this instance should build required quantities. */
    shouldBuildRequiredQuantities: boolean;
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the name of the customer. */
    customerName?: string | undefined;
    /** Gets or sets the region identifier. */
    regionId?: string | undefined;
    /** Gets or sets the required quantities classification. */
    requiredQuantitiesClassification: AssetTypeClassification;
}

/** Asset Damage Dto. */
export interface AssetDamageHistoryDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
    /** Gets or sets the container status. */
    containerStatus: ContainerStatus;
    /** Gets or sets the last updated date. */
    lastUpdatedDate: moment.Moment;
    /** Gets or sets the created by. */
    createdById: string;
    /** Gets or sets the created by. */
    createdBy?: string | undefined;
    /** Gets or sets the created comment. */
    createdComment?: string | undefined;
    /** Gets or sets the last updated by identifier. */
    lastUpdatedById: string;
    /** Gets or sets the last updated by. */
    lastUpdatedBy?: string | undefined;
    /** Gets or sets the repaired date. */
    repairedDate?: moment.Moment | undefined;
    /** Gets or sets the repaired comment. */
    repairedComment?: string | undefined;
    /** Gets or sets the damage type identifier. */
    damageTypeId: number;
    /** Gets or sets the type of the damage. */
    damageType?: string | undefined;
    /** Gets or sets the damage image1 link. */
    damageImage1Link?: string | undefined;
    /** Gets or sets the damage image2 link. */
    damageImage2Link?: string | undefined;
    /** Gets or sets the repair image1 link. */
    repairImage1Link?: string | undefined;
    /** Gets or sets the repair image2 link. */
    repairImage2Link?: string | undefined;
    /** Gets or sets the created. */
    created?: moment.Moment | undefined;
    /** Gets or sets the damage group key. */
    damageGroupKey: string;
    /** Gets or sets the repair location identifier. */
    repairLocationId?: number | undefined;
    /** Gets or sets the sent for repair date. */
    sentForRepairDate?: moment.Moment | undefined;
    /** Gets or sets the sent for repair by. */
    sentForRepairBy?: string | undefined;
    /** Gets or sets the sent for repair by identifier. */
    sentForRepairById?: string | undefined;
    /** Gets or sets the sent forrepair comment. */
    sentForRepairComment?: string | undefined;
}

/** Container Status. */
export enum ContainerStatus {
    InService = 0,
    Damaged = 1,
    DamagedInService = 2,
}

export enum DeviceType {
    Yabby4G = 0,
    Barra4G = 1,
    BarraCore = 2,
    BarraEdge = 3,
    Bolt = 4,
    Bolt2 = 5,
    Dart = 6,
    Dart2 = 7,
    Dart32G = 8,
    Dart34G = 9,
    Dart34GBluetooth = 10,
    Dart3GlobalBluetooth = 11,
    Eagle = 12,
    FalconCellular = 13,
    G62 = 14,
    G702G = 15,
    G704G = 16,
    G704GBluetooth = 17,
    G1204G = 18,
    G150Global = 19,
    Hawk = 20,
    MantaFusion = 21,
    OysterV1Cellular = 22,
    Oyster2 = 23,
    Oyster34G = 24,
    Oyster34GBluetooth = 25,
    Oyster3Global = 26,
    OysterEdge4G = 27,
    Remora = 28,
    Remora2 = 29,
    Remora34G = 30,
    Remora3Global = 31,
    YabbyEdge = 32,
    YabbyWifiCellular = 33,
    YabbyGPSCellular = 34,
}

/** Asset Device Position Update Dto. */
export interface AssetDevicePositionUpdateDto {
    /** Gets or sets the identifier. */
    id?: string | undefined;
    /** Gets or sets the device identifier. */
    deviceId: number;
    /** Gets or sets the update date time. */
    updateDateTime: moment.Moment;
    /** Gets or sets the asset. */
    asset?: string | undefined;
    /** Gets or sets the latitude. */
    latitude?: number | undefined;
    /** Gets or sets the longitude. */
    longitude?: number | undefined;
    /** Gets or sets the speed. */
    speed?: number | undefined;
    /** Gets or sets the location. */
    location?: CustomerLocationDto | undefined;
    /** Gets or sets the altitude. */
    altitude?: number | undefined;
    /** Gets or sets the constellation. */
    constellation?: number | undefined;
    /** Gets or sets the fix quality. */
    fixQuality?: number | undefined;
    /** Gets or sets the position source. */
    positionSource: PositionSource;
}

/** The Location Dto. */
export interface CustomerLocationDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type. */
    locationType?: string | undefined;
    /** Gets or sets the location type classification. */
    locationTypeClassification: LocationTypeClassification;
    /** Gets or sets the type of the secondary location. */
    secondaryLocationType?: string | undefined;
    /** Gets or sets the secondary location type classification. */
    secondaryLocationTypeClassification?: LocationTypeClassification | undefined;
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets the accuracy. */
    geofenceRadius: number;
    /** Gets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the name of the depot. */
    depotName?: string | undefined;
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets a value indicating whether this instance is rental. */
    isRental: boolean;
    /** Gets or sets the post code. */
    postCode?: string | undefined;
    /** Gets or sets a value indicating whether this instance has agreement. */
    hasAgreement: boolean;
    /** Gets or sets the name of the agreement customer. */
    agreementCustomerName?: string | undefined;
    /** Gets or sets the name of the agreement site. */
    agreementSiteName?: string | undefined;
    /** Gets or sets the agreement address1. */
    agreementAddress1?: string | undefined;
    /** Gets or sets the agreement address2. */
    agreementAddress2?: string | undefined;
    /** Gets or sets the agreement address3. */
    agreementAddress3?: string | undefined;
    /** Gets or sets the agreement address4. */
    agreementAddress4?: string | undefined;
    /** Gets or sets the agreement postcode. */
    agreementPostcode?: string | undefined;
    /** Gets or sets a value indicating whether this instance is deleted. */
    isDeleted: boolean;
    /** Gets or sets the customer region identifier. */
    customerRegionId?: string | undefined;
    /** Gets or sets the customer region name. */
    customerRegionName?: string | undefined;
    /** Gets or sets the summary. */
    summary?: string | undefined;
    /** Gets or sets created. */
    created?: moment.Moment | undefined;
    /** Gets or sets created display. */
    createdDisplay?: string | undefined;
    /** Gets or sets can have own bin. */
    canHaveOwnBin: boolean;
    /** Gets or sets has fixed bins. */
    hasFixedBins: boolean;
}

/** Location type classification. */
export enum LocationTypeClassification {
    Depot = 0,
    Customer = 1,
    Other = 2,
    NotShown = 3,
    Adhoc = 4,
    ExCustomerNotShown = 5,
}

export enum PositionSource {
    None = 0,
    GNSS = 1,
    WiFi = 2,
    Cell = 3,
    GNSS_WiFi = 4,
    GNSS_Cell = 5,
    WiFi_Cell = 6,
    GNSS_WiFi_Cell = 7,
    BLE = 8,
    Reused = 9,
}

/** Paged list dto. */
export interface PageListDtoOfAssetDevicePositionUpdateDto {
    /** Gets or sets the number of records. */
    numberOfRecords: number;
    /** Gets or sets the page number. */
    pageNumber: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
    /** Gets the number of pages. */
    numberOfPages: number;
    /** Gets a value indicating whether this instance has previous page. */
    hasPreviousPage: boolean;
    /** Gets or sets a value indicating whether this instance has next page. */
    hasNextPage: boolean;
    /** Gets or sets the items. */
    items?: AssetDevicePositionUpdateDto[] | undefined;
}

/** Asset Device Position Update Dto. */
export interface AssetDeviceVersusMovementDto {
    /** Gets or sets the identifier. */
    id?: string | undefined;
    /** Gets or sets the update date time. */
    updateDateTime: moment.Moment;
    /** Gets or sets the asset. */
    asset?: string | undefined;
    /** Gets or sets the latitude. */
    latitude?: number | undefined;
    /** Gets or sets the longitude. */
    longitude?: number | undefined;
    /** Gets or sets the speed. */
    speed?: number | undefined;
    /** Gets or sets the location. */
    yabbyLocation?: CustomerLocationDto | undefined;
    /** Gets or sets the movement location. */
    movementLocation?: string | undefined;
    /** Gets or sets the distance. */
    distanceBetween?: number | undefined;
}

/** Add Battery Tracker Note Request. */
export interface AddBatteryTrackerNoteRequest {
    /** Gets the device identifier. */
    deviceId: number;
    /** Gets the note. */
    note?: string | undefined;
    /** Gets or sets the type of the note. */
    noteType?: string | undefined;
}

/** Base model for paged lists. */
export interface PagedListBaseModelOfAssetDevicePositionUpdateDto {
    /** Gets the current page. */
    currentPage: number;
    /** Gets the total pages. */
    totalPages: number;
    /** Gets the size of the page. */
    pageSize: number;
    /** Gets the total total item count. */
    totalTotalItemCount: number;
    /** Gets a value indicating whether this instance has previous. */
    hasPrevious: boolean;
    /** Gets a value indicating whether this instance has next. */
    hasNext: boolean;
    /** Gets or sets the items. */
    items?: AssetDevicePositionUpdateDto[] | undefined;
}

/** Customer assets and locations view model. */
export interface CustomerAssetLocationModel {
    /** Gets or sets the assets. */
    assets?: CurrentAssetLocationDto[] | undefined;
    /** Gets or sets the location service. */
    locations?: CustomerLocationDto[] | undefined;
    /** Gets or sets the assets on the move. */
    assetsOnTheMove?: string[] | undefined;
    /** Gets the location types. */
    locationTypes?: LocationTypeDto[] | undefined;
    /** Gets the container groups. */
    containerGroups?: AssetTypeGroupDto[] | undefined;
    /** Gets all the container availability quantities. */
    containerAvailabilityQuantities?: ContainerAvailabilityQuantityDto[] | undefined;
}

/** Current asset location dto. */
export interface CurrentAssetLocationDto {
    /** Gets or sets the asset identifier. */
    id?: string | undefined;
    /** Gets or sets the name of the beacon. */
    beaconName?: string | undefined;
    /** Gets or sets the type of the asset. */
    assetType?: string | undefined;
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** The location depot id. */
    depotId: string;
    /** Gets or sets the asset URL. */
    assetURL?: string | undefined;
    /** Gets or sets the asset url2. */
    assetUrl2?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive: boolean;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the name of the location. */
    locationName?: string | undefined;
    /** Gets or sets the type of the location. */
    locationType?: string | undefined;
    /** Gets or sets the arrived at location date. */
    arrivedAtLocationDate: moment.Moment;
    /** Gets or sets the days at location. */
    daysAtLocation: number;
    /** Gets or sets the damaged date. */
    damagedDate?: moment.Moment | undefined;
    /** Gets or sets the response date. */
    responseDate?: moment.Moment | undefined;
    /** Gets or sets the location type classification. */
    locationTypeClassification: LocationTypeClassification;
    /** Gets or sets a value indicating whether this instance is yard bin. */
    isYardBin: boolean;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the container status. */
    containerStatus: ContainerStatus;
}

/** Location Type Dto. */
export interface LocationTypeDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the colour of this type of location. */
    colour?: string | undefined;
    /** Gets or sets the classification. */
    classification: LocationTypeClassification;
}

/** AssetTypeGroupDto. */
export interface AssetTypeGroupDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the category. */
    category: number;
    /** Gets or sets the size. */
    size: number;
    /** Gets or sets the asset types. */
    assetTypes?: AssetTypeDto[] | undefined;
}

/** Asset type dto. */
export interface AssetTypeDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
}

/** ContainerAvailabilityQuantityDto. */
export interface ContainerAvailabilityQuantityDto {
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the depot name. */
    depotName?: string | undefined;
    /** Gets or sets the asset type identifier. */
    assetTypeId?: number | undefined;
    /** Gets or sets the asset type name. */
    assetTypeName?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the required. */
    required?: number | undefined;
    /** Gets or sets the yard. */
    yard?: number | undefined;
    /** Gets or sets the location identifier. */
    locationId?: string | undefined;
    /** Gets or sets the location name. */
    locationName?: string | undefined;
    /** Gets or sets the asset type group identifier. */
    assetTypeGroupId?: number | undefined;
    /** Gets or sets the asset type group name. */
    assetTypeGroupName?: string | undefined;
    /** Gets or sets is fixed. */
    isFixed: boolean;
}

/** The ResetPriorityRequestModel. */
export interface ResetPriorityRequestModel {
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
}

/** The Beacon Scan DTO. */
export interface BeaconScanBodyDto {
    /** Gets or sets the beacons. */
    Beacons?: CreateBeaconScanDto[] | undefined;
    /** Gets or sets the reader. */
    Reader?: string | undefined;
}

/** The BeaconScan Dto. */
export interface CreateBeaconScanDto {
    /** Gets or sets the beacon address. */
    BeaconAddress?: string | undefined;
    /** Gets or sets the latitude. */
    locationSeenLatitude: number;
    /** Gets or sets the longitude. */
    locationSeenLongitude: number;
    /** Gets or sets the accuracy. */
    locationAccuracy: number;
    /** Gets or sets the last seen epoc. */
    lastSeen: number;
    /** Gets or sets the rssi. */
    Rssi: number;
}

/** The Blackbox DTO. */
export interface BlackboxDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the IMEI number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the vehicle registration. */
    vehicleRegistration?: string | undefined;
    /** Gets or sets the created. */
    created?: moment.Moment | undefined;
    /** Gets or sets the customer description. */
    customerDescription?: string | undefined;
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the name of the customer. */
    customerName?: string | undefined;
    /** The blackbox is active. */
    isActive: BlackboxStatus;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the vehicle type identifier. */
    vehicleTypeId: number;
    /** Gets or sets the name of the vehicle type. */
    vehicleTypeName?: string | undefined;
    /** Gets or sets a value indicating whether this blackbox has automatic location generation enabled. */
    isAutoLocationGenerationEnabled?: boolean | undefined;
    /** Gets or sets the is overnight stop location generation enabled. */
    isOvernightStopLocationGenerationEnabled?: boolean | undefined;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the depot name. */
    depotName?: string | undefined;
    /** Gets or sets the faults. */
    faults?: DeviceFaultDto[] | undefined;
}

/** Black box status. */
export enum BlackboxStatus {
    InActive = 0,
    Active = 1,
    Passive = 2,
}

/** Device fault status */
export interface DeviceFaultDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the status. */
    status?: string | undefined;
}

/** The Add Blackbox DTO. */
export interface AddBlackboxDto {
    /** Gets or sets the IMEI number. */
    imeiNumber?: string | undefined;
    /** Gets or sets the vehicle registration. */
    vehicleRegistration?: string | undefined;
    /** Gets or sets the customer description. */
    customerDescription?: string | undefined;
    /** Gets or sets the name of the customer. */
    customerName?: string | undefined;
    /** Gets or sets the type of the vehicle. */
    vehicleType?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive: BlackboxStatus;
    /** Gets or sets the name of the depot. */
    depotName?: string | undefined;
}

/** Toggle Blackbox Status Request. */
export interface ToggleBlackBoxStatusRequest {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the reason. */
    reason?: string | undefined;
}

/** The AssignAgreementRequest. */
export interface AssignAgreementRequest {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
    /** Gets or sets the location identifier. */
    locationId?: string | undefined;
    /** Gets or sets the agreement identifier. */
    agreementId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is update. */
    isUpdate: boolean;
}

/** ContainerAvailabilityResponse. */
export interface ContainerAvailabilityResponse {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the selected depot identifiers. */
    selectedDepotIds?: string[] | undefined;
    /** Gets or sets the region depot identifiers. */
    regionDepotIds?: string[] | undefined;
    /** The location identifiers; */
    locationIds?: string[] | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the roros. */
    roros?: ContainerAvailabilityGroup[] | undefined;
    /** Gets or sets the skips. */
    skips?: ContainerAvailabilityGroup[] | undefined;
    /** Gets or sets the others. */
    others?: ContainerAvailabilityGroup[] | undefined;
    /** Gets or sets the depot total. */
    depotTotal: number;
    /** Gets or sets the yard total. */
    yardTotal: number;
    /** Gets or sets the damaged total. */
    damagedTotal: number;
    /** Gets or sets the available total. */
    availableTotal: number;
    /** Gets or sets the required (used) total. */
    requiredTotal: number;
    /** Gets or sets the adjust total. */
    adjustTotal: number;
    /** Gets or sets the net required total. */
    netRequiredTotal: number;
    /** Gets or sets the surplus total. */
    surplusTotal: number;
    /** Gets or sets the deficit total. */
    deficitTotal: number;
    /** Gets or sets the net surplus total. */
    netSurplusTotal: number;
    /** Gets or sets the assets. */
    assets?: CurrentAssetLocationDto[] | undefined;
    /** Gets or sets the locations. */
    locations?: CustomerLocationDto[] | undefined;
    /** Gets or sets the location types. */
    locationTypes?: LocationTypeDto[] | undefined;
    /** Gets or sets the depot availability. */
    depotAvailability?: DepotAvailabilityResponse | undefined;
}

/** ContainerAvailabilityGroup. */
export interface ContainerAvailabilityGroup {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the category. */
    category: number;
    /** Gets or sets the size. */
    size: number;
    /** Gets or sets the depot count. */
    depotCount: number;
    /** Gets or sets the yard count. */
    yardCount: number;
    /** Gets or sets the yard value. */
    yardValue?: number | undefined;
    /** Gets or sets the damaged count. */
    damagedCount: number;
    /** Gets or sets the available count. */
    availableCount: number;
    /** Gets or sets the required (usage) count. */
    requiredCount: number;
    /** Gets or sets the required (usage) value. */
    requiredValue?: number | undefined;
    /** Gets or sets the adjust count. */
    adjustCount: number;
    /** Gets or sets the net required count. */
    netRequiredCount: number;
    /** Gets or sets the surplus count. */
    surplusCount: number;
    /** Gets or sets the deficit count. */
    deficitCount: number;
    /** Gets or sets the net surplus count. */
    netSurplusCount: number;
    /** Gets or sets the net surplus value. */
    netSurplusValue?: number | undefined;
    /** Gets or sets the net surplus color. */
    netSurplusColor?: string | undefined;
    /** Gets or sets the zero weeks surplus count. */
    zeroWeeksSurplusCount?: number | undefined;
    /** Gets or sets the zero weeks deficit count. */
    zeroWeeksDeficitCount?: number | undefined;
    /** Gets or sets the zero weeks net surplus count. */
    zeroWeeksNetSurplusCount?: number | undefined;
    /** Gets or sets the four weeks surplus count. */
    fourWeeksSurplusCount?: number | undefined;
    /** Gets or sets the four weeks deficit count. */
    fourWeeksDeficitCount?: number | undefined;
    /** Gets or sets the four weeks net surplus count. */
    fourWeeksNetSurplusCount?: number | undefined;
    /** Gets or sets the twelve weeks surplus count. */
    twelveWeeksSurplusCount?: number | undefined;
    /** Gets or sets the twelve weeks deficit count. */
    twelveWeeksDeficitCount?: number | undefined;
    /** Gets or sets the twelve weeks net surplus count. */
    twelveWeeksNetSurplusCount?: number | undefined;
    /** Gets or sets the four weeks trend percentage. */
    fourWeeksTrendPercentage?: number | undefined;
    /** Gets or sets the four weeks trend percentage color. */
    fourWeeksTrendPercentageColor?: string | undefined;
    /** Gets or sets the four weeks trend percentage display. */
    fourWeeksTrendPercentageDisplay?: string | undefined;
    /** Gets or sets the twelve weeks trend percentage. */
    twelveWeeksTrendPercentage?: number | undefined;
    /** Gets or sets the twelve weeks trend percentage color. */
    twelveWeeksTrendPercentageColor?: string | undefined;
    /** Gets or sets the twelve weeks trend percentage display. */
    twelveWeeksTrendPercentageDisplay?: string | undefined;
    /** Gets or sets the asset types. */
    assetTypes?: ContainerAvailabilityType[] | undefined;
    /** Gets or sets the compare depot count. */
    compareDepotCount?: number | undefined;
    /** Gets or sets the compare yard count. */
    compareYardCount?: number | undefined;
    /** Gets or sets the compare damaged count. */
    compareDamagedCount?: number | undefined;
    /** Gets or sets the compare available count. */
    compareAvailableCount?: number | undefined;
    /** Gets or sets the compare required count. */
    compareRequiredCount?: number | undefined;
    /** Gets or sets the compare adjust count. */
    compareAdjustCount?: number | undefined;
    /** Gets or sets the compare net required count. */
    compareNetRequiredCount?: number | undefined;
    /** Gets or sets the compare net surplus count. */
    compareNetSurplusCount?: number | undefined;
    /** Gets or sets the compare depot difference. */
    compareDepotDifference?: number | undefined;
    /** Gets or sets the compare yard difference. */
    compareYardDifference?: number | undefined;
    /** Gets or sets the compare damaged difference. */
    compareDamagedDifference?: number | undefined;
    /** Gets or sets the compare available difference. */
    compareAvailableDifference?: number | undefined;
    /** Gets or sets the compare required difference. */
    compareRequiredDifference?: number | undefined;
    /** Gets or sets the compare adjust difference. */
    compareAdjustDifference?: number | undefined;
    /** Gets or sets the compare net required difference. */
    compareNetRequiredDifference?: number | undefined;
    /** Gets or sets the compare net surplus difference. */
    compareNetSurplusDifference?: number | undefined;
    /** Gets or sets the compare depot count display. */
    compareDepotCountDisplay?: string | undefined;
    /** Gets or sets the compare depot yard display. */
    compareYardCountDisplay?: string | undefined;
    /** Gets or sets the compare depot damaged display. */
    compareDamagedCountDisplay?: string | undefined;
    /** Gets or sets the compare available count display. */
    compareAvailableCountDisplay?: string | undefined;
    /** Gets or sets the compare required count display. */
    compareRequiredCountDisplay?: string | undefined;
    /** Gets or sets the compare adjust count display. */
    compareAdjustCountDisplay?: string | undefined;
    /** Gets or sets the compare net required count display. */
    compareNetRequiredCountDisplay?: string | undefined;
    /** Gets or sets the compare net surplus count display. */
    compareNetSurplusCountDisplay?: string | undefined;
    /** Gets or sets the compare depot count color. */
    compareDepotCountColor?: string | undefined;
    /** Gets or sets the compare depot yard color. */
    compareYardCountColor?: string | undefined;
    /** Gets or sets the compare depot damaged color. */
    compareDamagedCountColor?: string | undefined;
    /** Gets or sets the compare available count color. */
    compareAvailableCountColor?: string | undefined;
    /** Gets or sets the compare required count color. */
    compareRequiredCountColor?: string | undefined;
    /** Gets or sets the compare adjust count color. */
    compareAdjustCountColor?: string | undefined;
    /** Gets or sets the compare net required count color. */
    compareNetRequiredCountColor?: string | undefined;
    /** Gets or sets the compare net surplus count color. */
    compareNetSurplusCountColor?: string | undefined;
}

/** ContainerAvailabilityType. */
export interface ContainerAvailabilityType {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the depot count. */
    depotCount: number;
    /** Gets or sets the yard count. */
    yardCount: number;
    /** Gets or sets the damaged count. */
    damagedCount: number;
    /** Gets or sets the available count. */
    availableCount: number;
    /** Gets or sets the required (usage) count. */
    requiredCount: number;
    /** Gets or sets the adjust count. */
    adjustCount: number;
    /** Gets or sets the net required count. */
    netRequiredCount: number;
    /** Gets or sets the surplus count. */
    surplusCount: number;
    /** Gets or sets the deficit count. */
    deficitCount: number;
    /** Gets or sets the net surplus count. */
    netSurplusCount: number;
    /** Gets or sets the net surplus color. */
    netSurplusColor?: string | undefined;
    /** Gets or sets the zero weeks surplus count. */
    zeroWeeksSurplusCount?: number | undefined;
    /** Gets or sets the zero weeks deficit count. */
    zeroWeeksDeficitCount?: number | undefined;
    /** Gets or sets the zero weeks net surplus count. */
    zeroWeeksNetSurplusCount?: number | undefined;
    /** Gets or sets the four weeks surplus count. */
    fourWeeksSurplusCount?: number | undefined;
    /** Gets or sets the four weeks deficit count. */
    fourWeeksDeficitCount?: number | undefined;
    /** Gets or sets the four weeks net surplus count. */
    fourWeeksNetSurplusCount?: number | undefined;
    /** Gets or sets the twelve weeks surplus count. */
    twelveWeeksSurplusCount?: number | undefined;
    /** Gets or sets the twelve weeks deficit count. */
    twelveWeeksDeficitCount?: number | undefined;
    /** Gets or sets the twelve weeks net surplus count. */
    twelveWeeksNetSurplusCount?: number | undefined;
    /** Gets or sets the four weeks trend percentage. */
    fourWeeksTrendPercentage?: number | undefined;
    /** Gets or sets the four weeks trend percentage color. */
    fourWeeksTrendPercentageColor?: string | undefined;
    /** Gets or sets the four weeks trend percentage display. */
    fourWeeksTrendPercentageDisplay?: string | undefined;
    /** Gets or sets the twelve weeks trend percentage. */
    twelveWeeksTrendPercentage?: number | undefined;
    /** Gets or sets the twelve weeks trend percentage color. */
    twelveWeeksTrendPercentageColor?: string | undefined;
    /** Gets or sets the twelve weeks trend percentage display. */
    twelveWeeksTrendPercentageDisplay?: string | undefined;
    /** Gets or sets the compare depot count. */
    compareDepotCount?: number | undefined;
    /** Gets or sets the compare yard count. */
    compareYardCount?: number | undefined;
    /** Gets or sets the compare damaged count. */
    compareDamagedCount?: number | undefined;
    /** Gets or sets the compare available count. */
    compareAvailableCount?: number | undefined;
    /** Gets or sets the compare required count. */
    compareRequiredCount?: number | undefined;
    /** Gets or sets the compare adjust count. */
    compareAdjustCount?: number | undefined;
    /** Gets or sets the compare net required count. */
    compareNetRequiredCount?: number | undefined;
    /** Gets or sets the compare net surplus count. */
    compareNetSurplusCount?: number | undefined;
    /** Gets or sets the compare depot difference. */
    compareDepotDifference?: number | undefined;
    /** Gets or sets the compare yard difference. */
    compareYardDifference?: number | undefined;
    /** Gets or sets the compare damaged difference. */
    compareDamagedDifference?: number | undefined;
    /** Gets or sets the compare available difference. */
    compareAvailableDifference?: number | undefined;
    /** Gets or sets the compare required difference. */
    compareRequiredDifference?: number | undefined;
    /** Gets or sets the compare adjust difference. */
    compareAdjustDifference?: number | undefined;
    /** Gets or sets the compare net required difference. */
    compareNetRequiredDifference?: number | undefined;
    /** Gets or sets the compare net surplus difference. */
    compareNetSurplusDifference?: number | undefined;
    /** Gets or sets the compare depot count display. */
    compareDepotCountDisplay?: string | undefined;
    /** Gets or sets the compare depot yard display. */
    compareYardCountDisplay?: string | undefined;
    /** Gets or sets the compare depot damaged display. */
    compareDamagedCountDisplay?: string | undefined;
    /** Gets or sets the compare available count display. */
    compareAvailableCountDisplay?: string | undefined;
    /** Gets or sets the compare required count display. */
    compareRequiredCountDisplay?: string | undefined;
    /** Gets or sets the compare adjust count display. */
    compareAdjustCountDisplay?: string | undefined;
    /** Gets or sets the compare net required count display. */
    compareNetRequiredCountDisplay?: string | undefined;
    /** Gets or sets the compare net surplus count display. */
    compareNetSurplusCountDisplay?: string | undefined;
    /** Gets or sets the compare depot count color. */
    compareDepotCountColor?: string | undefined;
    /** Gets or sets the compare depot yard color. */
    compareYardCountColor?: string | undefined;
    /** Gets or sets the compare depot damaged color. */
    compareDamagedCountColor?: string | undefined;
    /** Gets or sets the compare available count color. */
    compareAvailableCountColor?: string | undefined;
    /** Gets or sets the compare required count color. */
    compareRequiredCountColor?: string | undefined;
    /** Gets or sets the compare adjust count color. */
    compareAdjustCountColor?: string | undefined;
    /** Gets or sets the compare net required count color. */
    compareNetRequiredCountColor?: string | undefined;
    /** Gets or sets the compare net surplus count color. */
    compareNetSurplusCountColor?: string | undefined;
}

/** DepotAvailabilityResponse. */
export interface DepotAvailabilityResponse {
    /** Gets or sets the roros. */
    roros?: DepotAvailabilityGroup[] | undefined;
    /** Gets or sets the skips. */
    skips?: DepotAvailabilityGroup[] | undefined;
}

/** DepotAvailabilityGroup. */
export interface DepotAvailabilityGroup {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the category. */
    category: number;
    /** Gets or sets the size. */
    size: number;
    /** Gets or sets the depots. */
    depots?: DepotAvailabilityItem[] | undefined;
}

/** DepotAvailabilityItem. */
export interface DepotAvailabilityItem {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the available count. */
    availableCount: number;
    /** Gets or sets the net surplus count. */
    netSurplusCount: number;
    /** Gets or sets the net surplus color. */
    netSurplusColor?: string | undefined;
    /** Gets or sets the compare available count. */
    compareAvailableCount?: number | undefined;
    /** Gets or sets the compare net surplus count. */
    compareNetSurplusCount?: number | undefined;
    /** Gets or sets the compare available difference. */
    compareAvailableDifference?: number | undefined;
    /** Gets or sets the compare net surplus difference. */
    compareNetSurplusDifference?: number | undefined;
    /** Gets or sets the compare available count display. */
    compareAvailableCountDisplay?: string | undefined;
    /** Gets or sets the compare net surplus count display. */
    compareNetSurplusCountDisplay?: string | undefined;
    /** Gets or sets the compare available count color. */
    compareAvailableCountColor?: string | undefined;
    /** Gets or sets the compare net surplus count color. */
    compareNetSurplusCountColor?: string | undefined;
    /** Gets or sets the asset types. */
    assetTypes?: DepotAvailabilityType[] | undefined;
}

/** DepotAvailabilityType. */
export interface DepotAvailabilityType {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the available count. */
    availableCount: number;
    /** Gets or sets the net surplus count. */
    netSurplusCount: number;
    /** Gets or sets the net surplus color. */
    netSurplusColor?: string | undefined;
    /** Gets or sets the compare available count. */
    compareAvailableCount?: number | undefined;
    /** Gets or sets the compare net surplus count. */
    compareNetSurplusCount?: number | undefined;
    /** Gets or sets the compare available difference. */
    compareAvailableDifference?: number | undefined;
    /** Gets or sets the compare net surplus difference. */
    compareNetSurplusDifference?: number | undefined;
    /** Gets or sets the compare available count display. */
    compareAvailableCountDisplay?: string | undefined;
    /** Gets or sets the compare net surplus count display. */
    compareNetSurplusCountDisplay?: string | undefined;
    /** Gets or sets the compare available count color. */
    compareAvailableCountColor?: string | undefined;
    /** Gets or sets the compare net surplus count color. */
    compareNetSurplusCountColor?: string | undefined;
}

/** ContainerAvailabilityShow. */
export enum ContainerAvailabilityShow {
    All = 0,
    Surplus = 1,
    Deficit = 2,
}

/** Customer dto. */
export interface CustomerDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the prefix. */
    prefix?: string | undefined;
    /** Gets or sets the logo URL. */
    logoUrl?: string | undefined;
    /** Gets or sets a value indicating whether this instance is automatic location generation enabled. */
    isAutoLocationGenerationEnabled: boolean;
    /** Gets or sets a value indicating whether this instance is overnight stop location generation enabled. */
    isOvernightStopLocationGenerationEnabled: boolean;
    /** Gets or sets the last waste type allocation date. */
    lastWasteTypeAllocationDate?: moment.Moment | undefined;
    /** Gets or sets the adhoc location type identifier. */
    adhocLocationTypeId: string;
    /** Gets or sets the overnight stop location type identifier. */
    overnightStopLocationTypeId: string;
    /** Gets or sets the customer location type identifier. */
    customerLocationTypeId: string;
}

/** CustomerDetailsResponse. */
export interface CustomerDetailsResponse {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the region depot identifiers. */
    regionDepotIds?: string[] | undefined;
    /** The region identifier; */
    regionId?: string | undefined;
    /** The depot identifier; */
    depotId?: string | undefined;
    /** The location identifier; */
    locationId?: string | undefined;
    /** Gets or sets the depot total. */
    depotTotal: number;
    /** Gets or sets the yard total. */
    yardTotal: number;
    /** Gets or sets the damaged total. */
    damagedTotal: number;
    /** Gets or sets the available total. */
    availableTotal: number;
    /** Gets or sets the required (used) total. */
    requiredTotal: number;
    /** Gets or sets the adjust total. */
    adjustTotal: number;
    /** Gets or sets the net required total. */
    netRequiredTotal: number;
    /** Gets or sets the surplus total. */
    surplusTotal: number;
    /** Gets or sets the deficit total. */
    deficitTotal: number;
    /** Gets or sets the net surplus total. */
    netSurplusTotal: number;
    /** Gets or sets the locations. */
    locations?: CustomerLocationDto[] | undefined;
    /** Gets or sets the location types. */
    locationTypes?: LocationTypeDto[] | undefined;
}

/** Customer Setting Dto. */
export interface CustomerSettingDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the key. */
    key?: string | undefined;
    /** Gets or sets the type. */
    typeName?: string | undefined;
    /** Gets or sets the value. */
    settingValue?: string | undefined;
}

/** Viewmodel response for live dashboard page. */
export interface LiveDashboardResponse {
    /** Gets or sets the vehicle jobs. */
    vehicleJobs?: VehicleJobListItemDto[] | undefined;
    /** Gets or sets the services. */
    services?: LocationServiceDto[] | undefined;
    /** Gets or sets the in transit. */
    inTransit?: InTransitDto[] | undefined;
    /** Gets or sets the number of services. */
    numberOfServices: number;
    /** Gets or sets the number of jobs. */
    numberOfJobs: number;
    /** Gets or sets the miles driven. */
    milesDriven?: number | undefined;
    /** Gets the location types. */
    locationTypes?: LocationTypeDto[] | undefined;
    /** Gets or sets the depots. */
    depots?: DepotDto[] | undefined;
}

/** Vehicle job list item. */
export interface VehicleJobListItemDto {
    /** Gets or sets the vehicle identifier. */
    vehicleId: string;
    /** Gets or sets the name of the vehicle. */
    vehicleName?: string | undefined;
    /** Gets or sets the jobs. */
    jobs?: JourneyItemDto[] | undefined;
}

/** The job item dashboard dto. */
export interface JourneyItemDto {
    /** Gets or sets the movement identifier. */
    movementId: string;
    /** Gets or sets the vehicle identifier. */
    vehicleId: string;
    /** Gets or sets the name of the vehicle. */
    vehicleName?: string | undefined;
    /** Gets or sets the departed date time. */
    departedAt?: moment.Moment | undefined;
    /** Gets or sets from location identifier. */
    fromLocationId: string;
    /** Gets or sets from location. */
    fromLocation?: string | undefined;
    /** Gets or sets from location latitude. */
    fromLocationLatitude?: number | undefined;
    /** Gets or sets from location longitude. */
    fromLocationLongitude?: number | undefined;
    /** Gets or sets the name of from location type. */
    fromLocationTypeName?: string | undefined;
    /** Gets or sets the container name. */
    containerId?: string | undefined;
    /** Gets or sets the journey time minutes. */
    journeyTimeMinutes?: number | undefined;
    /** Gets or sets the to location identifier. */
    toLocationId?: string | undefined;
    /** Gets or sets the to location. */
    toLocation?: string | undefined;
    /** Gets or sets the to location latitude. */
    toLocationLatitude?: number | undefined;
    /** Gets or sets the to location longitude. */
    toLocationLongitude?: number | undefined;
    /** Gets or sets the to location type name. */
    toLocationTypeName?: string | undefined;
    /** Gets or sets the arrived at. */
    arrivedAt?: moment.Moment | undefined;
    /** Gets or sets the variance. */
    variance?: number | undefined;
    /** Gets or sets the data key. */
    dataKey?: string | undefined;
    /** Gets or sets a value indicating whether this JourneyItemDto is alert. */
    alert: boolean;
    /** Gets or sets the mileage. */
    mileage?: number | undefined;
    /** Gets or sets the mileage variance. */
    mileageVariance?: number | undefined;
}

/** Service item dto. */
export interface LocationServiceDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the vehicle identifier. */
    vehicleId: string;
    /** Gets or sets the name of the vehicle. */
    vehicleName?: string | undefined;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the name of the location. */
    locationName?: string | undefined;
    /** Gets or sets the name of the location type. */
    locationTypeName?: string | undefined;
    /** Gets or sets the location type classification. */
    locationTypeClassification: LocationTypeClassification;
    /** Gets or sets the name of the secondary location type. */
    secondaryLocationTypeName?: string | undefined;
    /** Gets or sets the secondary location type classification. */
    secondaryLocationTypeClassification?: LocationTypeClassification | undefined;
    /** Gets or sets the arrived at. */
    arrivedAt: moment.Moment;
    /** Gets or sets the departed at. */
    departedAt: moment.Moment;
    /** Gets the time at site. */
    timeAtSite?: number | undefined;
    /** Gets or sets the variance. */
    variance?: number | undefined;
    /** Gets or sets the container in. */
    containerIn?: string | undefined;
    /** Gets or sets the container out. */
    containerOut?: string | undefined;
    /** Gets or sets the movement identifier. */
    movementIds?: string[] | undefined;
    /** Gets or sets a value indicating whether this LocationServiceDto is alert. */
    alert: boolean;
    /** Gets or sets the job type description. */
    jobTypeDescription?: string | undefined;
}

/** In Transit Dto. */
export interface InTransitDto {
    /** Gets or sets from location identifier. */
    fromLocationId: string;
    /** Gets or sets the name of from location. */
    fromLocationName?: string | undefined;
    /** Gets or sets from location latitude. */
    fromLocationLatitude: number;
    /** Gets or sets from location longitude. */
    fromLocationLongitude: number;
    /** Gets or sets the name of from location type. */
    fromLocationTypeName?: string | undefined;
    /** Gets or sets the vehicle identifier. */
    vehicleId: string;
    /** Gets or sets the name of the vehicle. */
    vehicleName?: string | undefined;
    /** Gets or sets the vehicle longitude. */
    vehicleLongitude?: number | undefined;
    /** Gets or sets the vehicle latitude. */
    vehicleLatitude?: number | undefined;
    /** Gets or sets from location identifier. */
    toLocationId?: string | undefined;
    /** Gets or sets the name of To location. */
    toLocationName?: string | undefined;
    /** Gets or sets To location latitude. */
    toLocationLatitude?: number | undefined;
    /** Gets or sets To location longitude. */
    toLocationLongitude?: number | undefined;
    /** Gets or sets the name of To location type. */
    toLocationTypeName?: string | undefined;
    /** Gets or sets a value indicating whether this InTransitDto is alert. */
    alert: boolean;
    /** Gets or sets the movement identifier. */
    movementId?: string | undefined;
}

/** Live dashboard request. */
export interface LiveDashboardRequest {
    /** Gets or sets the customer identifier. */
    customerId?: string | undefined;
    /** Gets or sets the blackbox identifier. */
    blackboxId?: string[] | undefined;
    /** Gets or sets the location identifier. */
    locationId?: string[] | undefined;
    /** Gets or sets the depot identifier. */
    depotId?: string[] | undefined;
    /** Gets or sets the type of the vehicle. */
    vehicleType?: string | undefined;
    /** Gets or sets a value indicating whether [only show irregular information]. */
    onlyShowIrregularInfo: boolean;
    /** Gets or sets a value indicating whether to [return all rows]. */
    returnAllRows: boolean;
}

/** Viewmodel response for live dashboard page. */
export interface ActiveDashboardResponse {
    /** Gets or sets the vehicle jobs. */
    jobs?: JourneyItemDto[] | undefined;
    /** Gets or sets the services. */
    services?: LocationServiceDto[] | undefined;
    /** Gets or sets the number of services. */
    numberOfServices: number;
    /** Gets or sets the number of jobs. */
    numberOfJobs: number;
    /** Gets or sets the miles driven. */
    milesDriven?: number | undefined;
    /** Gets the location types. */
    locationTypes?: LocationTypeDto[] | undefined;
    /** Gets or sets the depots. */
    depots?: DepotDto[] | undefined;
}

/** Active dashboard request. */
export interface ActiveDashboardRequest {
    /** Gets or sets the customer identifier. */
    customerId?: string | undefined;
    /** Gets or sets the date. */
    startDate?: moment.Moment | undefined;
    /** Gets or sets the date. */
    endDate?: moment.Moment | undefined;
    /** Gets or sets the blackbox identifier. */
    blackboxId?: string[] | undefined;
    /** Gets or sets the location identifier. */
    locationId?: string[] | undefined;
    /** Gets or sets the depot identifier. */
    depotId?: string[] | undefined;
    /** Gets or sets the type of the vehicle. */
    vehicleType?: string | undefined;
    /** Gets or sets a value indicating whether [only show irregular information]. */
    onlyShowIrregularInfo: boolean;
    /** Gets or sets a value indicating whether to [return all rows]. */
    returnAllRows: boolean;
}

/** Kpi data response model. */
export interface KpiDataResponse {
    /** Gets the kpi data. */
    data?: KpiDataItemDto[] | undefined;
    /** Gets a value indicating whether [show next button]. */
    showNextButton: boolean;
    /** Gets or sets the four week trend. */
    fourWeekTrend?: KpiDataItemDto | undefined;
    /** Gets or sets the twelve week trend. */
    twelveWeekTrend?: KpiDataItemDto | undefined;
}

/** Kpi data item. */
export interface KpiDataItemDto {
    /** Gets or sets the containers at customer. */
    containersAtCustomer?: number | undefined;
    /** Gets or sets the containers at depot. */
    containersAtDepot?: number | undefined;
    /** Gets or sets the total container days. */
    totalContainerDays?: number | undefined;
    /** Gets or sets the slow movers. */
    slowMovers?: number | undefined;
    /** Gets or sets the slow moving days. */
    slowMovingDays?: number | undefined;
    /** Gets or sets the average container dwell. */
    averageContainerDwell?: number | undefined;
    /** Gets or sets the service frequency. */
    serviceFrequency?: number | undefined;
    /** Gets or sets the service frequency average. */
    serviceFrequencyAverage?: number | undefined;
    /** Gets or sets the collections in week. */
    collectionsInWeek?: number | undefined;
    /** Gets or sets the deliveries in week. */
    deliveriesInWeek?: number | undefined;
    /** Gets or sets the exchanges in week. */
    exchangesInWeek?: number | undefined;
    /** Gets or sets the containers at other. */
    containersAtOther?: number | undefined;
    /** Gets or sets the total jobs. */
    totalJobs?: number | undefined;
    /** Gets or sets the total containers. */
    totalContainers?: number | undefined;
    /** Gets or sets the item date. */
    itemDate: moment.Moment;
    /** Gets or sets the display date which is the week ending date. */
    displayDate: moment.Moment;
    /** Gets or sets the projected annual collections. */
    projectedAnnualCollections?: number | undefined;
    /** Gets or sets the row title. */
    rowTitleOverride?: string | undefined;
    /** Gets or sets the row header. */
    rowHeader?: string | undefined;
}

/** Kpi Request Model. */
export interface KpiRequestModel {
    /** Gets or sets the customer identifier. */
    customerId?: string | undefined;
    /** Gets or sets the start date. */
    startDate?: moment.Moment | undefined;
    /** Gets or sets the type of the asset. */
    assetType?: string[] | undefined;
    /** Gets or sets the depot identifier. */
    depotId?: string[] | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification?: AssetTypeClassification[] | undefined;
}

/** Viewmodel response for location services page. */
export interface LocationServiceResponse {
    /** Gets or sets the services. */
    services?: LocationServiceInformationDto[] | undefined;
}

/** Service information item dto. */
export interface LocationServiceInformationDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the vehicle identifier. */
    vehicleId: string;
    /** Gets or sets the name of the vehicle. */
    vehicleName?: string | undefined;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the name of the location. */
    locationName?: string | undefined;
    /** Gets or sets the name of the location type. */
    locationTypeName?: string | undefined;
    /** Gets or sets the arrived at. */
    arrivedAt: moment.Moment;
    /** Gets or sets the departed at. */
    departedAt: moment.Moment;
    /** Gets the time at site. */
    timeAtSite?: number | undefined;
    /** Gets or sets the variance. */
    variance?: number | undefined;
    /** Gets or sets the container in. */
    containerIn?: string | undefined;
    /** Gets or sets the container out. */
    containerOut?: string | undefined;
    /** Gets or sets the movement identifier. */
    movementIds?: string[] | undefined;
    /** Gets or sets a value indicating whether this LocationServiceDto is alert. */
    alert: boolean;
    /** Gets or sets the waste identifier. */
    wasteId?: number | undefined;
    /** Gets or sets the type of the waste. */
    wasteType?: string | undefined;
    /** Gets or sets the source location. */
    sourceLocation?: string | undefined;
    /** Gets or sets the source location identifier. */
    sourceLocationId?: string | undefined;
    /** Gets or sets the name of the source location type. */
    sourceLocationTypeName?: string | undefined;
}

/** Location services request. */
export interface LocationServiceRequest {
    /** Gets or sets the customer identifier. */
    customerId?: string | undefined;
    /** Gets or sets the date. */
    startDate?: moment.Moment | undefined;
    /** Gets or sets the date. */
    endDate?: moment.Moment | undefined;
    /** Gets or sets the blackbox identifier. */
    blackboxId?: string[] | undefined;
    /** Gets or sets the destination location identifier. */
    destinationLocationId?: string[] | undefined;
    /** Gets or sets the source location identifier. */
    sourceLocationId?: string[] | undefined;
    /** Gets or sets the depot identifier. */
    depotId?: string[] | undefined;
    /** Gets or sets a value indicating whether [only show irregular information]. */
    onlyShowIrregularInfo: boolean;
    /** Gets or sets the waste identifier. */
    wasteId?: number[] | undefined;
}

/** Add Beacon Scans Request. */
export interface AddBeaconScansRequest {
    /** Gets the blackbox identifier. */
    blackboxId: string;
    /** Gets the asset identifier. */
    assetId?: string | undefined;
    /** Gets the start time. */
    startTime: moment.Moment;
    /** Gets the end time. */
    endTime: moment.Moment;
    /** Gets the number of scans. */
    numberOfScans: number;
    /** Gets the location identifier. */
    locationId?: string | undefined;
}

/** Delete Beacon Scans Request. */
export interface DeleteBeaconScansRequest {
    /** Gets the blackbox identifier. */
    blackboxId: string;
    /** Gets the asset identifier. */
    assetId?: string | undefined;
    /** Gets the start time. */
    startTime: moment.Moment;
    /** Gets the end time. */
    endTime: moment.Moment;
}

/** ChangeBeaconScanLocationRequest. */
export interface ChangeBeaconScanLocationRequest {
    /** Gets or sets the old location identifier. */
    oldLocationId: string;
    /** Creates new locationid. */
    newLocationId: string;
}

/** ChangeRogueBeaconScanLocationRequest. */
export interface ChangeRogueBeaconScanLocationRequest {
    /** Gets or sets the old location identifier. */
    oldLocationId: string;
    /** Creates new locationid. */
    newLocationId: string;
}

/** UpdateBlackBoxPositionRequest. */
export interface UpdateBlackBoxPositionRequest {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the latitude. */
    latitude?: number | undefined;
    /** Gets or sets the longitude. */
    longitude?: number | undefined;
}

/** RenameAssetRequest. */
export interface RenameAssetRequest {
    /** Gets or sets from identifier. */
    fromId?: string | undefined;
    /** Converts to id. */
    toId?: string | undefined;
}

/** RenameBlackboxRequest. */
export interface RenameBlackboxRequest {
    /** Gets or sets the blackbox identifier. */
    blackboxId: string;
    /** Gets or sets from identifier. */
    fromName?: string | undefined;
    /** Converts to id. */
    toName?: string | undefined;
}

/** ChangeBlackboxDescriptionRequest. */
export interface ChangeBlackboxDescriptionRequest {
    /** Gets or sets the blackbox identifier. */
    blackboxId: string;
    /** Gets or sets from identifier. */
    description?: string | undefined;
}

/** RegionDto. */
export interface RegionDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the depots. */
    depots?: DepotDto[] | undefined;
}

/** Embedded config. */
export interface EmbedParams {
    /** Type of the object to be embedded. */
    type?: string | undefined;
    /** Report to be embedded. */
    embedReport?: EmbedReport[] | undefined;
    /** Embed Token for the Power BI report. */
    embedToken?: EmbedToken | undefined;
}

/** Embed report config. */
export interface EmbedReport {
    /** Id of Power BI report to be embedded. */
    reportId: string;
    /** Name of the report. */
    reportName?: string | undefined;
    /** Embed URL for the Power BI report. */
    embedUrl?: string | undefined;
}

export interface EmbedToken {
    token?: string | undefined;
    tokenId: string;
    expiration: moment.Moment;
}

/** BillingDetailsData. */
export interface BillingDetailsData {
    /** BillingDetailsRecords. */
    billingDetailsRecords?: BillingDetailsRecord[] | undefined;
}

/** BillingDetailsRecord. */
export interface BillingDetailsRecord {
    /** Id. */
    id?: string | undefined;
    /** CustomerName. */
    customerName?: string | undefined;
    /** DepotName. */
    depotName?: string | undefined;
    /** Type. */
    type?: string | undefined;
    /** Skips. */
    skips: number;
    /** RoRos. */
    roRos: number;
    /** AllVehicles. */
    allVehicles: number;
    /** SkipVehicles. */
    skipVehicles: number;
    /** RoRoVehicles. */
    roRoVehicles: number;
    /** MobileScanner. */
    mobileScanner: number;
    /** DateCreated. */
    dateCreated?: moment.Moment | undefined;
    /** DateCreatedDisplay. */
    dateCreatedDisplay?: string | undefined;
    /** DateDeleted. */
    dateDeleted?: moment.Moment | undefined;
    /** DateDeletedDisplay. */
    dateDeletedDisplay?: string | undefined;
    /** Reason. */
    reason?: string | undefined;
}

/** BillingSummaryData. */
export interface BillingSummaryData {
    /** BillingSummaryRecords. */
    billingSummaryRecords?: BillingSummaryRecord[] | undefined;
}

/** BillingSummaryRecord. */
export interface BillingSummaryRecord {
    /** Name. */
    name?: string | undefined;
    /** DepotName. */
    depotName?: string | undefined;
    /** AllContainers. */
    allContainers: number;
    /** Skips. */
    skips: number;
    /** RoRos. */
    roRos: number;
    /** AllVehicles. */
    allVehicles: number;
    /** SkipVehicles. */
    skipVehicles: number;
    /** RoRoVehicles. */
    roRoVehicles: number;
    /** MobileScanner. */
    mobileScanner: number;
    /** CheckShouldBe0. */
    checkShouldBe0: number;
}

/** Assign Agreementh ViewModel. */
export interface AssignAgreementhViewModel {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the customer identifier. */
    locationId?: string | undefined;
    /** Gets or sets the alert identifier. */
    alertId: number;
    /** Creates new locationname. */
    newLocationName?: string | undefined;
    /** Gets or sets the depot identifier. */
    depotId?: string | undefined;
}

/** VerifyJobRequest. */
export interface VerifyJobRequest {
    /** Gets or sets the job identifier. */
    jobId: number;
    /** Gets or sets a value indicating whether this instance is correct. */
    isCorrect?: boolean | undefined;
}

/** JobsModel. */
export interface JobsModel {
    /** Gets or sets the jobs. */
    jobs?: JobBasicDto[] | undefined;
    /** Gets or sets current page. */
    currentPage: number;
    /** Gets or sets has next. */
    hasNext: boolean;
    /** Gets or sets has previous. */
    hasPrevious: boolean;
    /** Gets or sets page size. */
    pageSize: number;
    /** Gets or sets total pages. */
    totalPages: number;
    /** Gets or sets total item count. */
    totalItemCount: number;
}

/** The job dto. */
export interface JobBasicDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the started. */
    started: moment.Moment;
    /** Gets or sets the finished. */
    finished: moment.Moment;
    /** Gets or sets the finished display. */
    finishedDisplay?: string | undefined;
    /** Gets or sets the job type identifier. */
    jobTypeId: number;
    /** Gets or sets the job type name. */
    jobTypeName?: string | undefined;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the location name. */
    locationName?: string | undefined;
    /** Gets or sets the container in. */
    containerIn?: string | undefined;
    /** Gets or sets the container in type identifier. */
    containerInTypeId?: number | undefined;
    /** Gets or sets the container in type name. */
    containerInTypeName?: string | undefined;
    /** Gets or sets the container out. */
    containerOut?: string | undefined;
    /** Gets or sets the container out type identifier. */
    containerOutTypeId?: number | undefined;
    /** Gets or sets the container out type name. */
    containerOutTypeName?: string | undefined;
    /** Gets or sets the black box depot identifier. */
    blackBoxDepotId: string;
    /** Gets or sets the black box name. */
    blackBoxName?: string | undefined;
}

/** LocationContainersModel. */
export interface LocationContainersModel {
    /** Gets or sets the location. */
    location?: CustomerLocationDto | undefined;
    /** Gets or sets the container positions. */
    containerPositions?: ContainerPositionDto[] | undefined;
    /** Gets or sets the positions total. */
    containersTotal: number;
    /** Gets or sets the positions total. */
    positionsTotal: number;
    /** Gets or sets the pins total. */
    pinsTotal: number;
}

/** ContainerPositionDto. */
export interface ContainerPositionDto {
    /** Gets or sets the container name. */
    containerName?: string | undefined;
    /** Gets or sets the container type. */
    containerType?: string | undefined;
    /** Gets or sets the external reference. */
    externalReference?: string | undefined;
    /** Gets or sets the waste type name. */
    wasteTypeName?: string | undefined;
    /** Gets or sets the days on site. */
    daysOnSite: number;
    /** Gets or sets days on site. */
    daysOnSiteDisplay?: string | undefined;
    /** Gets or sets the asset type name. */
    position?: GeoPosition | undefined;
    /** Gets or sets is known. */
    isKnown: boolean;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets is yard bin. */
    isYardBin: boolean;
    /** Gets or sets damaged date. */
    damagedDate?: moment.Moment | undefined;
    /** Gets or sets response date. */
    responseDate?: moment.Moment | undefined;
    /** Gets or sets the container status. */
    containerStatus: ContainerStatus;
    /** Gets or sets the status name. */
    statusName?: string | undefined;
    /** Gets or sets the status display. */
    statusDisplay?: string | undefined;
    /** Gets or sets the asset URL. */
    assetURL?: string | undefined;
}

/** Geo position. */
export interface GeoPosition {
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets the geofence. */
    geofence?: Coordinate[] | undefined;
}

export interface Coordinate {
    x: number;
    y: number;
    z: number;
    m: number;
    coordinateValue?: Coordinate | undefined;
    isValid: boolean;
}

/** Add autogen location dto. */
export interface AddAutoGenLocationDto {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the location type identifier. */
    locationTypeId: string;
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets a value indicating whether this instance is ro ro. */
    isRoRo: boolean;
    /** Gets or sets the process date time. */
    processDateTime: moment.Moment;
    /** Gets or sets the name of the location. */
    locationName?: string | undefined;
    /** Gets or sets the geofence radius. */
    geoFenceRadius?: number | undefined;
    /** Gets or sets the geofence. */
    geoFence?: string | undefined;
}

/** Base model for paged lists. */
export interface PagedListBaseModelOfCustomerLocationDto {
    /** Gets the current page. */
    currentPage: number;
    /** Gets the total pages. */
    totalPages: number;
    /** Gets the size of the page. */
    pageSize: number;
    /** Gets the total total item count. */
    totalTotalItemCount: number;
    /** Gets a value indicating whether this instance has previous. */
    hasPrevious: boolean;
    /** Gets a value indicating whether this instance has next. */
    hasNext: boolean;
    /** Gets or sets the items. */
    items?: CustomerLocationDto[] | undefined;
}

/** A page of customer locations. */
export interface CustomerLocationPage extends PagedListBaseModelOfCustomerLocationDto {
}

/** Location Find Request. */
export interface LocationFindRequest {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the depot identifier. */
    depotId?: string | undefined;
    /** Gets or sets the location type identifier. */
    locationTypeId?: string | undefined;
    /** Gets or sets the size of the page. */
    pageSize: number;
    /** Gets or sets the page identifier. */
    pageId: number;
    /** Gets the only show not set locations. */
    onlyShowNotSetLocations: boolean;
    /** Gets or sets the search. */
    search?: LocationFindRequestSearchParams | undefined;
    draw: number;
    /** Gets a value indicating whether [only show deleted]. */
    onlyShowDeleted: boolean;
    /** Gets created since. */
    createdSince?: moment.Moment | undefined;
}

export interface LocationFindRequestSearchParams {
    /** Gets or sets the value. */
    value?: string | undefined;
    /** Gets or sets a value indicating whether [reg ex]. */
    regex: boolean;
}

/** Edit Location Request. */
export interface EditLocationRequest {
    /** Gets the location identifier. */
    locationId: string;
    /** Gets the name. */
    name?: string | undefined;
    /** Gets the depot identifier. */
    depotId?: string | undefined;
    /** Gets the location type identifier. */
    locationTypeId: string;
    /** Gets or sets the secondary location type identifier. */
    secondaryLocationTypeId?: string | undefined;
    /** Gets or sets a value indicating whether this instance is deleted. */
    isDeleted: boolean;
}

/** Merge Location Request. */
export interface MergeLocationRequest {
    /** Gets the  source location identifier. */
    sourceLocationId: string;
    /** Gets or sets the destination location identifier. */
    destinationLocationId: string;
}

/** Simple search view model. */
export interface SimpleSearchViewModel {
    /** Gets or sets the customer identifier. */
    customerId?: string | undefined;
    /** Gets or sets the search term. */
    searchTerm?: string | undefined;
    /** Gets or sets the size of the page. */
    pageSize: number;
    /** Gets or sets the page identifier. */
    pageId: number;
    /** Gets or sets the only show not set locations (locations with no lat/lon). */
    onlyShowNotSetLocations: boolean;
}

/** Update geo fence view model. */
export interface UpdateGeoFenceViewModel {
    /** The location identifier */
    customerId: string;
    /** The location identifier */
    locationId: string;
    /** The latitide. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets the geo fence radius. */
    geoFenceRadius: number;
    /** Gets or sets the geofence. */
    geoFence?: string | undefined;
}

/** Location Detail Model. */
export interface LocationDetailModel {
    /** Gets or sets the location. */
    location?: CustomerLocationDto | undefined;
    /** Gets or sets the assets on site. */
    assetsOnSite?: CurrentAssetLocationDto[] | undefined;
    /** Gets or sets the average turn around graph data. */
    averageTurnAroundGraphData?: GraphDataSeriesModel[] | undefined;
    /** Gets or sets the average dwell graph data. */
    averageDwellGraphData?: GraphDataSeriesModel[] | undefined;
    /** Gets the order data. */
    orderData?: IntegrationReportDataDto | undefined;
    /** Gets the container groups. */
    containerGroups?: AssetTypeGroupDto[] | undefined;
    /** Gets or sets the container positions. */
    containerPositions?: ContainerPositionDto[] | undefined;
}

/** Model for returning graph series data. */
export interface GraphDataSeriesModel {
    /** Gets or sets the series name. */
    name?: string | undefined;
    /** Gets or sets the series. */
    series?: GraphDataItem[] | undefined;
}

/** Graph Series Data Item. */
export interface GraphDataItem {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the value. */
    value: number;
}

/** IntegrationReportDataDto. */
export interface IntegrationReportDataDto {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the depot identifier. */
    depotId?: string | undefined;
    /** Gets or sets the selected depot identifiers. */
    selectedDepotIds?: string[] | undefined;
    /** Gets or sets the agreements. */
    agreements?: PageListDtoOfIntegrationReportAgreementDto | undefined;
    /** Gets the customer locations. */
    customerLocations?: CustomerLocationDto[] | undefined;
    /** Gets the default agreements from date. */
    defaultAgreementsFromDate: moment.Moment;
    /** Gets the default agreements from date string. */
    defaultAgreementsFromDateString?: string | undefined;
    /** Gets or sets the default rental days. */
    defaultRentalDays: number;
    /** Gets or sets the default rental amount roros. */
    defaultRentalAmountRoros: number;
    /** Gets or sets the default rental amount skips. */
    defaultRentalAmountSkips: number;
    /** Gets or sets the sub total agreements. */
    subTotalAgreements: number;
    /** Gets or sets the sub total matched containers. */
    subTotalMatchedContainers: number;
    /** Gets or sets the sub total unmatched containers. */
    subTotalUnmatchedContainers: number;
    /** Gets or sets the total agreements. */
    totalAgreements: number;
    /** Gets or sets the total matched containers. */
    totalMatchedContainers: number;
    /** Gets or sets the total unmatched containers. */
    totalUnmatchedContainers: number;
    /** Gets or sets a value indicating whether this instance is any rent. */
    isAnyRent: boolean;
    /** Gets or sets the this week rent. */
    thisWeekRent: number;
    /** Gets or sets the this week rent display. */
    thisWeekRentDisplay?: string | undefined;
    /** Gets or sets the total rent. */
    totalRent: number;
    /** Gets the total rent display. */
    totalRentDisplay?: string | undefined;
}

/** Paged list dto. */
export interface PageListDtoOfIntegrationReportAgreementDto {
    /** Gets or sets the number of records. */
    numberOfRecords: number;
    /** Gets or sets the page number. */
    pageNumber: number;
    /** Gets or sets the size of the page. */
    pageSize: number;
    /** Gets the number of pages. */
    numberOfPages: number;
    /** Gets a value indicating whether this instance has previous page. */
    hasPreviousPage: boolean;
    /** Gets or sets a value indicating whether this instance has next page. */
    hasNextPage: boolean;
    /** Gets or sets the items. */
    items?: IntegrationReportAgreementDto[] | undefined;
}

/** Base model for paged lists. */
export interface PagedListBaseModelOfLocationServiceDto {
    /** Gets the current page. */
    currentPage: number;
    /** Gets the total pages. */
    totalPages: number;
    /** Gets the size of the page. */
    pageSize: number;
    /** Gets the total total item count. */
    totalTotalItemCount: number;
    /** Gets a value indicating whether this instance has previous. */
    hasPrevious: boolean;
    /** Gets a value indicating whether this instance has next. */
    hasNext: boolean;
    /** Gets or sets the items. */
    items?: LocationServiceDto[] | undefined;
}

/** Service page. */
export interface LocationServicesPage extends PagedListBaseModelOfLocationServiceDto {
}

/** Location Trip Request */
export interface LocationDataRequest {
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the customer identifier. */
    customerId?: string | undefined;
    /** Gets or sets the start date. */
    startDate: moment.Moment;
    /** Gets or sets the end date. */
    endDate: moment.Moment;
    /** Gets or sets the black box ids. */
    blackBoxIds?: string[] | undefined;
    /** Gets or sets the size of the page. */
    pageSize: number;
    /** Gets or sets the page identifier. */
    pageId: number;
}

/** Base model for paged lists. */
export interface PagedListBaseModelOfJourneyItemDto {
    /** Gets the current page. */
    currentPage: number;
    /** Gets the total pages. */
    totalPages: number;
    /** Gets the size of the page. */
    pageSize: number;
    /** Gets the total total item count. */
    totalTotalItemCount: number;
    /** Gets a value indicating whether this instance has previous. */
    hasPrevious: boolean;
    /** Gets a value indicating whether this instance has next. */
    hasNext: boolean;
    /** Gets or sets the items. */
    items?: JourneyItemDto[] | undefined;
}

/** Service page. */
export interface LocationJobsPage extends PagedListBaseModelOfJourneyItemDto {
}

/** The Loka Scan Dto. */
export interface LokaScanDto {
    /** Gets or sets the source. */
    src?: string | undefined;
    /** Gets or sets the location. */
    location?: LocationDto | undefined;
}

/** The Location Dto. */
export interface LocationDto {
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets the accuracy. */
    accuracy: number;
}

/** Dto for adding meta data types. */
export interface AddMetaDataTypeDto {
    /** Gets or sets the name of the type. */
    typeName?: string | undefined;
    /** Gets or sets the name of the customer. */
    customerName?: string | undefined;
    /** Gets or sets a value indicating whether [primary type]. */
    primaryType: boolean;
    /** Gets or sets the values. */
    values?: string[] | undefined;
}

/** Meta Data Type Dto. */
export interface MetaDataTypeDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets a value indicating whether [primary type]. */
    primaryType: boolean;
    /** Gets or sets the name of the type. */
    typeName?: string | undefined;
    /** Gets or sets the name of the customer. */
    customerName?: string | undefined;
    /** Gets or sets the values. */
    values?: MetaDataDto[] | undefined;
}

/** Meta data dto. */
export interface MetaDataDto {
    /** Gets or sets the identifier. */
    id: string;
    /** Gets or sets the value. */
    value?: string | undefined;
}

/** Journey detail model. */
export interface JourneyDetailModel {
    /** Gets or sets the job. */
    job?: JourneyItemDto | undefined;
    /** Gets or sets the journey positions. */
    journeyPositions?: BlackboxPositionDto[] | undefined;
    /** Gets the snap to roads information. */
    snapToRoadsInformation?: string | undefined;
}

/** Black box positions. */
export interface BlackboxPositionDto {
    /** Gets or sets the identifier. */
    id?: string | undefined;
    /** Gets or sets the black box identifier. */
    blackBoxId: string;
    /** Gets or sets the created date. */
    created: moment.Moment;
    /** Gets or sets the update date time. */
    updateDateTime: moment.Moment;
    /** Gets or sets the altitude. */
    altitude?: number | undefined;
    /** Direction of travel in degrees from north pole. */
    bearing?: number | undefined;
    /** GPS Quality indicator. */
    fixQuality?: number | undefined;
    /** Gets or sets the satellites in view. */
    satellitesInView?: number | undefined;
    /** Latitude in decimal degrees format. */
    latitude?: number | undefined;
    /** Longitude in decimal degrees format. */
    longitude?: number | undefined;
    /** Speed in km/h. */
    speed?: number | undefined;
    /** Gets or sets the mileage. */
    odometer?: number | undefined;
    /** Gets or sets a value indicating whether this instance is idle event. */
    isIdleEvent: boolean;
    /** Gets or sets a value indicating whether this instance is crash event. */
    isCrashEvent: boolean;
    /** Gets or sets the location. */
    location?: CustomerLocationDto | undefined;
}

/** Add movement dto. */
export interface AddMovementCorrectionDto {
    /** The asset. */
    asset?: string | undefined;
    /** Gets or sets from location identifier. */
    fromLocationId?: string | undefined;
    /** Converts to locationid. */
    toLocationId?: string | undefined;
    /** Gets or sets the arrived at. */
    arrivedAt?: moment.Moment | undefined;
}

/** AddContainerCorrectionDto. */
export interface AddContainerCorrectionDto {
    /** The asset. */
    asset?: string | undefined;
    /** Gets or sets from location identifier. */
    fromLocationId: string;
    /** Gets or sets to location identifier. */
    toLocationId: string;
    /** Gets or sets should create assignment. */
    shouldCreateAssignment: boolean;
    /** Gets or sets location agreement identifier. */
    locationAgreementId?: number | undefined;
    /** Gets or sets the arrived at. */
    arrivedAt?: moment.Moment | undefined;
}

export interface SaveMovementDetailsRequest {
    /** Gets or sets the movement identifier. */
    movementId: string;
    /** Gets or sets the snap to roads information. */
    snapToRoadsInformation?: string | undefined;
}

/** Delete Position Request Model. */
export interface DeletePositionRequestModel {
    /** Gets or sets the blackbox position identifier. */
    blackboxPositionId?: string[] | undefined;
}

/** Edit Position Request Model. */
export interface EditPositionRequestModel {
    /** Gets or sets the blackbox position identifier. */
    blackboxPositionId?: string[] | undefined;
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
}

/** ContainerAvailabilityReportData. */
export interface ContainerAvailabilityReportData {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the selected depot identifiers. */
    selectedDepotIds?: string[] | undefined;
    /** Gets or sets the region depot identifiers. */
    regionDepotIds?: string[] | undefined;
    /** The location identifiers; */
    locationIds?: string[] | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the from date time. */
    fromDateTime: moment.Moment;
    /** Gets or sets the to date time. */
    toDateTime: moment.Moment;
    /** Gets or sets the roros. */
    roros?: ContainerAvailabilityGroup2[] | undefined;
    /** Gets or sets the skips. */
    skips?: ContainerAvailabilityGroup2[] | undefined;
    /** Gets or sets the others. */
    others?: ContainerAvailabilityGroup2[] | undefined;
    /** Gets or sets the start asset total. */
    startAssetTotal: number;
    /** Gets or sets the end asset total. */
    endAssetTotal: number;
    /** Gets or sets the start customer container total. */
    startCustomerContainerTotal?: number | undefined;
    /** Gets or sets the end customer container total. */
    endCustomerContainerTotal?: number | undefined;
    /** Gets or sets the all job total. */
    allJobTotal: number;
    /** Gets or sets the low total. */
    lowTotal: number;
    /** Gets or sets the high total. */
    highTotal: number;
    /** Gets or sets the used total. */
    usedTotal: number;
    /** Gets or sets the surplus total. */
    surplusTotal: number;
    /** Gets or sets the change total. */
    changeTotal: number;
    /** Gets or sets the operational disturbance percentage. */
    operationalDisturbancePercentage: number;
    /** Gets or sets the operational disturbance percentage display. */
    operationalDisturbancePercentageDisplay?: string | undefined;
    /** Gets or sets the growth percentage. */
    growthPercentage?: number | undefined;
    /** Gets or sets the growth percentage display. */
    growthPercentageDisplay?: string | undefined;
    /** Gets or sets the required. */
    required?: number | undefined;
    /** Gets or sets the assets. */
    assets?: CurrentAssetLocationDto[] | undefined;
    /** Gets or sets the locations. */
    locations?: CustomerLocationDto[] | undefined;
}

/** ContainerAvailabilityGroup. */
export interface ContainerAvailabilityGroup2 {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the category. */
    category: number;
    /** Gets or sets the size. */
    size: number;
    /** Gets or sets the start asset count. */
    startAssetCount?: number | undefined;
    /** Gets or sets the end asset count. */
    endAssetCount?: number | undefined;
    /** Gets or sets the start customer container count. */
    startCustomerContainerCount?: number | undefined;
    /** Gets or sets the end customer container count. */
    endCustomerContainerCount?: number | undefined;
    /** Gets or sets the all job count. */
    allJobCount?: number | undefined;
    /** Gets or sets the value. */
    value?: number | undefined;
    /** Gets or sets the value date time. */
    valueDateTime?: moment.Moment | undefined;
    /** Gets or sets the low count. */
    lowCount?: number | undefined;
    /** Gets or sets the low date time. */
    lowDateTime?: moment.Moment | undefined;
    /** Gets or sets the high count. */
    highCount?: number | undefined;
    /** Gets or sets the high date time. */
    highDateTime?: moment.Moment | undefined;
    /** Gets or sets the used count. */
    usedCount?: number | undefined;
    /** Gets or sets the used value. */
    usedValue?: number | undefined;
    /** Gets or sets the surplus count. */
    surplusCount?: number | undefined;
    /** Gets or sets the change count. */
    changeCount?: number | undefined;
    /** Gets or sets the operational disturbance percentage. */
    operationalDisturbancePercentage: number;
    /** Gets or sets the operational disturbance percentage display. */
    operationalDisturbancePercentageDisplay?: string | undefined;
    /** Gets or sets the growth percentage. */
    growthPercentage?: number | undefined;
    /** Gets or sets the growth percentage display. */
    growthPercentageDisplay?: string | undefined;
    /** Gets or sets the required. */
    required?: number | undefined;
    /** Gets or sets the required value. */
    requiredValue?: number | undefined;
    /** Gets or sets the asset types. */
    assetTypes?: ContainerAvailabilityType2[] | undefined;
}

/** ContainerAvailabilityType. */
export interface ContainerAvailabilityType2 {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the start asset count. */
    startAssetCount?: number | undefined;
    /** Gets or sets the end asset count. */
    endAssetCount?: number | undefined;
    /** Gets or sets the start customer container count. */
    startCustomerContainerCount?: number | undefined;
    /** Gets or sets the end customer container count. */
    endCustomerContainerCount?: number | undefined;
    /** Gets or sets the all job count. */
    allJobCount?: number | undefined;
    /** Gets or sets the value. */
    value?: number | undefined;
    /** Gets or sets the low count. */
    lowCount?: number | undefined;
    /** Gets or sets the high count. */
    highCount?: number | undefined;
    /** Gets or sets the used count. */
    usedCount?: number | undefined;
    /** Gets or sets the surplus count. */
    surplusCount?: number | undefined;
    /** Gets or sets the change count. */
    changeCount?: number | undefined;
    /** Gets or sets the operational disturbance percentage. */
    operationalDisturbancePercentage: number;
    /** Gets or sets the operational disturbance percentage display. */
    operationalDisturbancePercentageDisplay?: string | undefined;
    /** Gets or sets the growth percentage. */
    growthPercentage?: number | undefined;
    /** Gets or sets the growth percentage display. */
    growthPercentageDisplay?: string | undefined;
    /** Gets or sets the required. */
    required?: number | undefined;
    /** Gets or sets the required count. */
    requiredCount?: number | undefined;
}

/** CollectionContainerDto. */
export interface CollectionContainerDto {
    /** Gets or sets the action date. */
    actionDate: moment.Moment;
    /** Gets or sets the action date display. */
    actionDateDisplay?: string | undefined;
    /** Gets or sets the external reference. */
    externalReference?: string | undefined;
    /** Gets or sets the asset identifier. */
    assetId?: string | undefined;
    /** Gets or sets the asset type identifier. */
    assetTypeId: number;
    /** Gets or sets the asset type name. */
    assetTypeName?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification: AssetTypeClassification;
    /** Gets or sets the depot name. */
    depotName?: string | undefined;
    /** Gets or sets the location name. */
    locationName?: string | undefined;
    /** Gets or sets the user name. */
    userName?: string | undefined;
    /** Gets or sets the user name display. */
    userNameDisplay?: string | undefined;
    /** Gets or sets the days on site. */
    daysOnSite: number;
    /** Gets or sets the latest action date. */
    latestActionDate?: moment.Moment | undefined;
    /** Gets or sets the latest action description. */
    latestActionDescription?: string | undefined;
    /** Gets or sets the latest action display. */
    latestActionDisplay?: string | undefined;
    /** Gets or sets the next action date. */
    nextActionDate?: moment.Moment | undefined;
    /** Gets or sets the next action description. */
    nextActionDescription?: string | undefined;
    /** Gets or sets the last action display. */
    nextActionDisplay?: string | undefined;
    /** Gets or sets the variance description. */
    varianceDescription?: string | undefined;
}

/** CollectionsReportSortColumn. */
export enum CollectionsReportSortColumn {
    None = 0,
    ActionDate = 1,
    Contract = 2,
    Container = 3,
}

/** CollectionsReportSortType. */
export enum CollectionsReportSortType {
    None = 0,
    Ascending = 1,
    Descending = 2,
}

/** CollectionUserDto. */
export interface CollectionUserDto {
    /** Gets or sets the user identifier. */
    userId: string;
    /** Gets or sets the user name. */
    userName?: string | undefined;
    /** Gets or sets the user name display. */
    userNameDisplay?: string | undefined;
}

/** IntegrationReportShowFilter. */
export enum IntegrationReportShowFilter {
    None = 0,
    All = 1,
    NewAgreements = 2,
    ContainerOnSite = 3,
    NoContainerOnSite = 4,
    Discrepancies = 5,
    SlowMovers = 6,
    NoAgreement = 7,
    RecentlyUpdated = 8,
    MissingCollection = 9,
    MovedContract = 10,
}

/** IntegrationReportOrderStatus. */
export enum IntegrationReportOrderStatus {
    None = 0,
    ContainerNotYetDelivered = 1,
    ContainerOnSite = 2,
    ExpectedContainerNotFound = 3,
    ServiceCompleted = 4,
}

/** IntegrationReportSortColumn. */
export enum IntegrationReportSortColumn {
    None = 0,
    AgreementReference = 1,
    ContainersOnSite = 2,
    TimeOnSite = 3,
    ServiceFrequency = 4,
    LatestDate = 5,
    LatestAction = 6,
}

/** IntegrationReportSortType. */
export enum IntegrationReportSortType {
    None = 0,
    Ascending = 1,
    Descending = 2,
}

/** IntegrationReportAgreementDetails. */
export interface IntegrationReportAgreementDetails {
    /** Reference. */
    reference?: string | undefined;
    /** DepotId. */
    depotId: string;
    /** ContactEmail. */
    contactEmail?: string | undefined;
    /** ContactName. */
    contactName?: string | undefined;
    /** ContactNumber. */
    contactNumber?: string | undefined;
    /** Notes. */
    notes?: string | undefined;
    /** Assignments. */
    assignments?: IntegrationReportAssignmentDto[] | undefined;
}

/** The EfficiencyReportDataResponse. */
export interface EfficiencyReportDataResponse {
    /** Gets or sets the operating hours. */
    operatingHours: number;
    /** Gets the journey variance. */
    journeyVariance: number;
    /** Gets the depot variance. */
    depotVariance: number;
    /** Gets the customer variance. */
    customerVariance: number;
    /** Gets the total variance. */
    totalVariance: number;
    /** Gets the break time. */
    breakTime: number;
    /** Gets or sets the efficiency percentage. */
    efficiencyPercentage: number;
    /** Gets or sets the vehicle shifts. */
    vehicleShifts: number;
}

/** AssignmentSort. */
export enum AssignmentSort {
    None = 0,
    MostRecent = 1,
    AssetId = 2,
    AssetType = 3,
    Location = 4,
    Status = 5,
    Agreement = 6,
}

/** The add untracked asset request. */
export interface AddUntrackedAssetRequest {
    /** Gets or sets the movement identifier. */
    movementId?: string | undefined;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the should adjust other. */
    shouldAdjustOther: boolean;
}

/** The Untracked Assets Dto. */
export interface UntrackedAssetsDto {
    /** The logs. */
    logs?: UntrackedAssetLogDto[] | undefined;
    /** The locations. */
    locations?: UntrackedAssetLocationDto[] | undefined;
}

/** The Untracked Asset Log DTO. */
export interface UntrackedAssetLogDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the created. */
    created: moment.Moment;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the movement identifier. */
    movementId?: string | undefined;
    /** Gets or sets the created by identifier. */
    createdById?: string | undefined;
    /** Gets or sets the movement. */
    movement?: MovementDto | undefined;
    /** Gets or sets the job. */
    job?: JobDto | undefined;
}

/** Movement dto. */
export interface MovementDto {
    /** Gets or sets the identifier. */
    id: string;
    /** The asset. */
    asset?: string | undefined;
    /** Gets or sets the departed at. */
    departedAt?: moment.Moment | undefined;
    /** Gets or sets from location identifier. */
    fromLocationId?: string | undefined;
    /** Gets or sets from location. */
    fromLocation?: string | undefined;
    /** Gets or sets from location latitude. */
    fromLocationLatitude?: number | undefined;
    /** Gets or sets from location longitude. */
    fromLocationLongitude?: number | undefined;
    /** Gets or sets the arrived at. */
    arrivedAt?: moment.Moment | undefined;
    /** Converts to locationid. */
    toLocationId?: string | undefined;
    /** Converts to location. */
    toLocation?: string | undefined;
    /** Converts to location latitude. */
    toLocationLatitude?: number | undefined;
    /** Converts to location longitude. */
    toLocationLongitude?: number | undefined;
    /** Gets or sets the reader. */
    reader?: string | undefined;
    /** Gets or sets the last seen. */
    lastSeen?: moment.Moment | undefined;
    /** The blackbox id. */
    blackBoxId?: string | undefined;
    /** Gets or sets the vehicle description. */
    vehicleDescription?: string | undefined;
    /** Gets or sets the type of the movement. */
    movementType?: string | undefined;
    /** Gets or sets the mileage. */
    mileage?: number | undefined;
    /** Gets or sets a value indicating whether this instance is correction. */
    isCorrection: boolean;
    /** Gets or sets the asset type identifier. */
    assetTypeId?: number | undefined;
    /** Gets or sets the name of the asset type. */
    assetTypeName?: string | undefined;
    /** Gets or sets the asset type classification. */
    assetTypeClassification?: AssetTypeClassification | undefined;
    /** Gets or sets a value indicating whether this instance is planned. */
    isPlanned: boolean;
    /** Gets or sets the name of the asset anonymous. */
    assetAnonymousName?: string | undefined;
    /** Converts to locationtype. */
    toLocationType?: string | undefined;
    /** Converts to locationanonymousname. */
    toLocationAnonymousName?: string | undefined;
    /** Converts to locationanonymouslatitude. */
    toLocationAnonymousLatitude?: number | undefined;
    /** Converts to locationanonymouslongitude. */
    toLocationAnonymousLongitude?: number | undefined;
    /** Gets or sets the type of from location. */
    fromLocationType?: string | undefined;
    /** Gets or sets the name of from location anonymous. */
    fromLocationAnonymousName?: string | undefined;
    /** Gets or sets from location anonymous latitude. */
    fromLocationAnonymousLatitude?: number | undefined;
    /** Gets or sets from location anonymous longitude. */
    fromLocationAnonymousLongitude?: number | undefined;
    /** Gets or sets the blackbox anonymous description. */
    blackboxAnonymousDescription?: string | undefined;
    /** Converts to locationcustomerprefix. */
    toLocationCustomerPrefix?: string | undefined;
    /** Gets or sets from location customer prefix. */
    fromLocationCustomerPrefix?: string | undefined;
    /** Gets or sets a value indicating whether this instance is created by device. */
    isCreatedByDevice: boolean;
    /** Converts to locationdepotid. */
    toLocationDepotId?: string | undefined;
    /** Gets or sets from location depot identifier. */
    fromLocationDepotId?: string | undefined;
    /** Gets or sets the black box depot identifier. */
    blackBoxDepotId?: string | undefined;
    /** Gets or sets the from location can have own bin. */
    fromLocationCanHaveOwnBin: boolean;
    /** Gets or sets the to location can have own bin. */
    toLocationCanHaveOwnBin: boolean;
    /** Gets or sets the correction assignment date time. */
    correctionAssignmentDateTime?: moment.Moment | undefined;
}

/** The job dto. */
export interface JobDto {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the vehicle identifier. */
    vehicleId: string;
    /** Gets or sets the name of the vehicle. */
    vehicleName?: string | undefined;
    /** Gets or sets the vehicle description. */
    vehicleDescription?: string | undefined;
    /** Gets or sets the started. */
    started: moment.Moment;
    /** Gets or sets the finished. */
    finished: moment.Moment;
    /** Gets or sets the job type identifier. */
    jobTypeId: number;
    /** Gets or sets the name of the job type. */
    jobTypeName?: string | undefined;
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the name of the location. */
    locationName?: string | undefined;
    /** Gets or sets the depot identifier. */
    depotId: string;
    /** Gets or sets the location type classification. */
    locationTypeClassification: LocationTypeClassification;
    /** Gets or sets the container in. */
    containerIn?: string | undefined;
    /** Gets or sets the container in type identifier. */
    containerInTypeId?: number | undefined;
    /** Gets or sets the container in type name. */
    containerInTypeName?: string | undefined;
    /** Gets or sets the container in type classification. */
    containerInTypeClassification?: AssetTypeClassification | undefined;
    /** Gets or sets the container out. */
    containerOut?: string | undefined;
    /** Gets or sets the container out type identifier. */
    containerOutTypeId?: number | undefined;
    /** Gets or sets the container out type name. */
    containerOutTypeName?: string | undefined;
    /** Gets or sets the container out type classification. */
    containerOutTypeClassification?: AssetTypeClassification | undefined;
    /** Gets or sets the created. */
    created?: moment.Moment | undefined;
    /** Gets or sets a value indicating whether this instance is planned. */
    isPlanned: boolean;
    /** Gets or sets the is correct. */
    isCorrect?: boolean | undefined;
    /** Gets or sets the verified date time. */
    verifiedDateTime?: moment.Moment | undefined;
    /** Gets or sets the verified user identifier. */
    verifiedUserId?: string | undefined;
    /** Gets or sets the name of the verified user. */
    verifiedUserName?: string | undefined;
}

/** The Untracked Asset Location Dto. */
export interface UntrackedAssetLocationDto {
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the quantity. */
    quantity: number;
}

/** The user details of the logged in user. */
export interface UserDetailsResponse {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the company identifier. */
    customerId?: string | undefined;
    /** Gets or sets a value indicating whether this instance is admin. */
    isAdmin: boolean;
    /** Gets or sets the role. */
    role?: string | undefined;
    /** Gets or sets the name of the user. */
    username?: string | undefined;
    /** Gets or sets the user claims. */
    userClaims?: UserClaim[] | undefined;
    /** Gets a value indicating whether this instance is head office user. */
    isHeadOfficeUser: boolean;
    /** Gets a value indicating whether this instance is finance user. */
    isFinanceUser: boolean;
}

/** User claims. */
export interface UserClaim {
    /** The claim type. */
    claimType?: string | undefined;
    /** The claim value. */
    claimValue?: string | undefined;
}

/** Create User Model. */
export interface CreateUserModel {
    /** Gets or sets the email address. */
    emailAddress: string;
    /** Gets or sets the password. */
    password: string;
    /** Gets or sets the forename. */
    forename: string;
    /** Gets or sets the surname. */
    surname: string;
    /** Gets or sets the name of the customer. */
    customerName?: string | undefined;
    /** Gets or sets the name of the depot. */
    depotName?: string | undefined;
    /** Gets or sets the can view integration report. */
    canViewIntegrationReport: boolean;
    /** Gets or sets the can view collections report. */
    canViewCollectionsReport: boolean;
    /** Gets or sets a value indicating whether [allow access to damage management]. */
    allowAccessToDamageManagement: boolean;
}

/** Reset user password model. */
export interface ResetUserPasswordModel {
    /** Gets or sets the email address. */
    emailAddress?: string | undefined;
    /** Gets or sets the password. */
    password?: string | undefined;
}

/** Wate type dto. */
export interface WasteTypeDto {
    /** Gets or sets the waste type identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Add Orders Request Model. */
export interface AddOrderRequestModel {
    /** Gets or sets the customer identifier. */
    customerId: string;
    /** Gets or sets the deployment identifier. */
    deploymentId: number;
    /** Gets or sets the fitter identifier. */
    fitterId: string;
    /** Gets or sets the order date. */
    orderDate: moment.Moment;
    /** Gets or sets the agreement ids. */
    agreementIds?: string | undefined;
}

/** Add Orders Request Model. */
export interface AddFitterJobRequestModel {
    /** Gets or sets the deployment identifier. */
    deploymentId?: number | undefined;
    /** Gets or sets the fitter identifier. */
    fitterId: string;
    /** Gets or sets the order date. */
    orderDate: moment.Moment;
    /** Gets the location identifier. */
    locationId: string;
    /** Gets the asset identifier. */
    assetId?: string | undefined;
    /** Gets the type of the fitter job. */
    fitterJobType: number;
}

/** Update works order status reques. */
export interface UpdateWorkOrderStatusRequestModel {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the status. */
    status: WorkOrderStatus;
}

/** Update works order status reques. */
export interface AddDeploymentRequestModel {
    /** Gets or sets the identifier. */
    customerId: string;
    /** Gets or sets the status. */
    name: string;
}

/** Update works order status reques. */
export interface ToggleDeploymentRequestModel {
    /** Gets or sets the identifier. */
    id: number;
}

/** MoveOrderRequestModel. */
export interface MoveOrderRequestModel {
    /** Gets or sets the location identifier. */
    locationId: string;
    /** Gets or sets the original fitter identifier. */
    originalFitterId: string;
    /** Gets or sets the original date. */
    originalDate: moment.Moment;
    /** Creates new fitterid. */
    newFitterId: string;
    /** Creates new date. */
    newDate: moment.Moment;
}

/** Sort Word Orders Request. */
export interface SortOrderRequestModel {
    /** Gets or sets the location ids. */
    locationIds?: string | undefined;
    /** Gets or sets the date. */
    date: moment.Moment;
    /** Gets or sets the fitter identifier. */
    fitterId: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}